import React, { useEffect, useState, useContext, useCallback, useRef, useMemo } from "react";
import axios from "axios";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../styles/ClientProfile.css";

const statusLabels = {
  1: "Probleme (Cu Revenire)",
  2: "Activ",
  3: "Montaj finalizat",
  4: "Dosar Prosumator",
  5: "Certificat de Racordare",
  6: "Vizite de teren",
  7: "Depus la MIPE",
  8: "Decedati & Rosu",
};

const OPTIUNI_INVERTOR_I7 = [
  "Solax 4.2kW nehibrid X1-BOOST-4.2K-G4",
  "Solax 5kW nehibrid X1-BOOST-5K-G4",
  "Solax 6kW nehibrid X1-BOOST-6K-G4",
  "Sofar Solar 5kW nehibrid 5KTLMG3",
  "Huawei 5kW nehibrid SUN2000-5KTL-L1",
];

const OPTIUNI_INVERTOR_I4A = [
  "Solax 3.7kW hibrid X1-HYBRID-3.7-D",
  "Solax 5kW hibrid X1-HYBRID-5.0-D",
  "Solax 6kW hibrid X1-HYBRID-6.0-D",
  "GoodWe 5kW hibrid ES G2 (GW5000-ES-20)",
  "LivolTek HP3-10KD2 10kW",
  "DEYE SUN-5K-SG05LP3-EU-SM2",
];

const MIN_POZE_PLAN_AMPLASAMENT = 2;

const MIN_POZE_VIZITA = {
  poza_acoperis: 2,
  poze_case_exterior: 4,
  poza_geamuri: 1,
  poza_grosime_perete: 1,
  poza_tablou: 1,
  poza_factura: 2,
  poza_extras_carte_funciara: 2,
};

const ClientProfile = () => {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const location = useLocation();
  const from = location.state?.from || "";

  const [client, setClient] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [error, setError] = useState(null);
  const [panelSeries, setPanelSeries] = useState([]);
  const [newPanel, setNewPanel] = useState("");
  const [prosumatorLogs, setProsumatorLogs] = useState([]);
  const [generalLogs, setGeneralLogs] = useState([]);
  const [newProsumatorLog, setNewProsumatorLog] = useState("");
  const [newGeneralLog, setNewGeneralLog] = useState("");
  const [showProsumatorModal, setShowProsumatorModal] = useState(false);
  const [showGeneralLogsModal, setShowGeneralLogsModal] = useState(false);
  const [lastStatusUpdate, setLastStatusUpdate] = useState("");
  const [lastUpdatedBy, setLastUpdatedBy] = useState("");
  const [documents, setDocuments] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState("poza_acoperis");
  const [lastPanelAddTime, setLastPanelAddTime] = useState(0);
  const [lastUploadTime, setLastUploadTime] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [acumulatorSeries, setAcumulatorSeries] = useState([]);
  const [newAcumulator, setNewAcumulator] = useState("");
  const [lastAcumulatorAddTime, setLastAcumulatorAddTime] = useState(0);
  const [invertorSeries, setInvertorSeries] = useState([]); 
  const [newInvertor, setNewInvertor] = useState(""); 
  const [lastInvertorAddTime, setLastInvertorAddTime] = useState(0); 
  const [smartMeterSeries, setSmartMeterSeries] = useState([]);
  const [newSmartMeter, setNewSmartMeter] = useState("");
  const [lastSmartMeterAddTime, setLastSmartMeterAddTime] = useState(0);
  const [DongleSeries, setDongleSeries] = useState([]);
  const [newDongle, setNewDongle] = useState("");
  const [lastDongleAddTime, setLastDongleAddTime] = useState(0);
  const [isVisitComplete, setIsVisitComplete] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [originalClientData, setOriginalClientData] = useState(null);
  const [statusReason, setStatusReason] = useState("");
  const [afiseazaSerii, setAfiseazaSerii] = useState(false);
  const [availableAssignees, setAvailableAssignees] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isChangingStatus, setIsChangingStatus] = useState(false); 
  const [isAddingPanel, setIsAddingPanel] = useState(false);
  const [panelAddedPing, setPanelAddedPing] = useState(false);
  const [isAddingAcumulator, setIsAddingAcumulator] = useState(false);
  const [acumulatorAddedPing, setAcumulatorAddedPing] = useState(false);
  const [isAddingInvertor, setIsAddingInvertor] = useState(false);
  const [invertorAddedPing, setInvertorAddedPing] = useState(false);
  const [isAddingSmartMeter, setIsAddingSmartMeter] = useState(false);
  const [smartMeterAddedPing, setSmartMeterAddedPing] = useState(false);
  const [isAddingDongle, setIsAddingDongle] = useState(false);
  const [DongleAddedPing, setDongleAddedPing] = useState(false);
  const [simInstalled, setSimInstalled] = useState(null); // null | "da" | "nu"
  const [simOperator, setSimOperator] = useState("");
  const [simIdentifier, setSimIdentifier] = useState("");
  const canEditSim = ["1", "2"].includes(String(client?.status));
  const [lastSavedSim, setLastSavedSim] = useState(null);
  const [isSavingSim, setIsSavingSim] = useState(false);
  const [simSaveMessage, setSimSaveMessage] = useState("");


  
  const hasAssignRights = (String(user?.role) === "1" || String(user?.role) === "2") && String(user?.i4b) === "1";
  const canAssign = hasAssignRights && String(client?.i4b) === "1";

  // const hasAssignRightsI4a = String(user?.role) === "1" && String(user?.i4a) === "1";
  // const canAssignI4a = hasAssignRightsI4a && String(client?.i4a) === "1";

  // const hasAssignRightsI7 = String(user?.role) === "1" && String(user?.i7) === "1";
  // const canAssignI7 = hasAssignRightsI7 && String(client?.i7) === "1";

  const firmeAtribuieLucrarea = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

  const firmeUserAtribuieLucrarea = firmeAtribuieLucrarea.filter(f => String(user?.[f]) === "1");
  const firmeClientAtribuieLucrarea = firmeAtribuieLucrarea.filter(f => String(client?.[f]) === "1");
  
  const firmeComuneAtribuieLucrare = firmeUserAtribuieLucrarea.filter(f => firmeClientAtribuieLucrarea.includes(f));
  
  const areOConjunctieDeFirma = 
    firmeUserAtribuieLucrarea.length === 1 &&
    firmeClientAtribuieLucrarea.length === 1 &&
    firmeComuneAtribuieLucrare.length === 1;  

  

  const [selectedContractFile, setSelectedContractFile] = useState(null);
  const [isContractUploading, setIsContractUploading] = useState(false);
  const contractFileInputRef = useRef(null);
  const contractDocuments = documents.filter(doc => doc.document_type === "contract_energie");

  const [activeDocTab, setActiveDocTab] = useState("");

  const tabCategories = useMemo(() => ({
    vizita: [
      "poza_acoperis",
      "poze_case_exterior",
      "poza_geamuri",
      "poza_grosime_perete",
      "poza_tablou",
      "poza_factura",
      "poza_extras_carte_funciara",
      "poze_plan_amplasament",
      "contract_energie",
      "poze_vizita",
    ],
    executie: [
      "poza_client_inainte", "priza_pamant", "poza_acoperis_dupa", "poza_casa_dupa", "poza_placuta", "poza_tablou_dupa", "poza_acumulatori_si_invertor", "factura_energie_si_poza_contor"
    ],
    altele: [
      "certificat_racordare", "dovada_prosumator", "proces_verbal", "proces_verbal_fotovoltaice", "proces_verbal_stocare", "contract_energie_actualizat", "alte_documente", "factura_voucher", "poze_pdf", "factura_delgaz", "dovada_delgaz", "dovada_prosumator_1", "dovada_prosumator_2"
    ]
  }), []);

  // ✅ Userul cu user_id 30 este exceptat de la regula firmei
  // user_id-urile exceptate
  const EXEMPT_USER_IDS = ["30", "18", "19", "2", "4", "5", "32"]; 

  // true dacă utilizatorul curent este exceptat
  const isExemptUser = EXEMPT_USER_IDS.includes(String(user?.user_id));


  // --- Paginare documente (7 / pagină) ---
  const DOCS_PER_PAGE = 7;
  const [docPage, setDocPage] = useState(1);
  const [visitDocPage, setVisitDocPage] = useState(1);

  const filteredDocuments = useMemo(
    () => documents.filter((doc) => tabCategories[activeDocTab]?.includes(doc.document_type)),
    [documents, activeDocTab, tabCategories]
  );

  const docTotalPages = Math.max(1, Math.ceil(filteredDocuments.length / DOCS_PER_PAGE));
  const docIndexOfLast = docPage * DOCS_PER_PAGE;
  const docIndexOfFirst = docIndexOfLast - DOCS_PER_PAGE;
  const currentDocs = filteredDocuments.slice(docIndexOfFirst, docIndexOfLast);

  // Documentele încărcate la Vizita de Teren
  const visitDocuments = useMemo(
    () =>
      documents.filter((document) =>
        tabCategories.vizita.includes(
          document.document_type
        )
      ),
    [documents, tabCategories]
  );

  const visitDocTotalPages = Math.max(
    1,
    Math.ceil(
      visitDocuments.length / DOCS_PER_PAGE
    )
  );

  const visitDocIndexOfLast =
    visitDocPage * DOCS_PER_PAGE;

  const visitDocIndexOfFirst =
    visitDocIndexOfLast - DOCS_PER_PAGE;

  const currentVisitDocs = visitDocuments.slice(
    visitDocIndexOfFirst,
    visitDocIndexOfLast
  );

  // Revine la pagina 1 când deschidem alt client
  useEffect(() => {
    setVisitDocPage(1);
  }, [id]);

  // Corectează pagina dacă se șterg documente
  useEffect(() => {
    if (visitDocPage > visitDocTotalPages) {
      setVisitDocPage(visitDocTotalPages);
    }
  }, [visitDocPage, visitDocTotalPages]);

  // Resetează pagina când se schimbă categoria
  useEffect(() => {
    setDocPage(1);
  }, [activeDocTab]);

  // Ajustează pagina curentă dacă se reduc documentele (ex. ștergeri / upload)
  useEffect(() => {
    const max = Math.max(1, Math.ceil(filteredDocuments.length / DOCS_PER_PAGE));
    if (docPage > max) setDocPage(max);
  }, [filteredDocuments.length, docPage]); 


  // === Tipuri echipamente (selectate DOAR local până la 2 -> 3) ===
  const [tipPanouSelectat, setTipPanouSelectat] = useState("");
  const [tipAcumulatorSelectat, setTipAcumulatorSelectat] = useState("");
  const [tipInvertorSelectat, setTipInvertorSelectat] = useState("");
 
  // 🔧 Opțiuni hardcodate
  const OPTIUNI_PANOU = [
    "Jinko Solar JKM450N-54HL4R-V 450W", "Aiko A460-MAH54Mw 460W", "Yingli Solar YL450CF48 i/2 450W Panda", "Trina Vertex S+ TSM-450NEG9R.28 450W", "Trina Vertex S+ TSM-460NEG9R.28 460W", "HX Solar - Hongyuan HY-NT10/54BGDF-450 450W", "Canadian Solar CS6.2-54TM-505 505W", "Talesun BiPro TM7G54M 108-cell 440W"
  ];

  const OPTIUNI_ACUMULATOR = [
    "Solax T30 T-BAT H 3.0 V2 (6kW)", "GoodWe 5kW Lynx U G3 (LX U5.0)", "LivolTek BHF-B10250 5.12kW"
  ];

  const OPTIUNI_INVERTOR_VIZIBILE = useMemo(() => {
    const isI7 = String(client?.i7) === "1";
    const isI4a = String(client?.i4a) === "1";
    if (isI7)  return OPTIUNI_INVERTOR_I7;
    if (isI4a) return OPTIUNI_INVERTOR_I4A;
    return []; // alt program: fără opțiuni (sau pune o listă generică dacă vrei)
  }, [client?.i7, client?.i4a]);  

  useEffect(() => {
    if (tipInvertorSelectat && !OPTIUNI_INVERTOR_VIZIBILE.includes(tipInvertorSelectat)) {
      setTipInvertorSelectat("");
    }
  }, [OPTIUNI_INVERTOR_VIZIBILE, tipInvertorSelectat]); 

  // Helpers pentru UI
  const esteStatus2 = String(client?.status) === "2";
  const areTipPanouInDB = !!client?.tippanou;
  const areTipAcumulatorInDB = !!client?.tipacumulator;
  const areTipInvertorInDB = !!client?.tipinvertor;

  const MAX_SERIES_LENGTH = 20;

  const normalizeSeries = (value) => value.trim().toLowerCase();

  const validateSeriesInput = (value, existingSeries, label) => {
    const trimmedValue = value.trim();

    if (trimmedValue === "") {
      alert("Introduceti o serie valida!");
      return null;
    }

    if (trimmedValue.length > MAX_SERIES_LENGTH) {
      alert(`Seria pentru ${label} nu poate avea mai mult de ${MAX_SERIES_LENGTH} caractere.`);
      return null;
    }

    const normalizedValue = normalizeSeries(trimmedValue);
    const alreadyExists = existingSeries.some(
      (item) => normalizeSeries(item) === normalizedValue
    );

    if (alreadyExists) {
      alert(`Seria introdusa exista deja la ${label}.`);
      return null;
    }

    return trimmedValue;
  };

  // Ready = există în DB (se salvează imediat la selectare)
  const tipPanouReady = areTipPanouInDB;
  const tipAcumulatorReady = areTipAcumulatorInDB;
  const tipInvertorReady = areTipInvertorInDB;
  
  // 🔴 Documente vizualizate (valabil doar până la refresh)
  const [visitedDocIds, setVisitedDocIds] = useState(() => new Set());

  const markDocVisited = useCallback((id) => {
    setVisitedDocIds((prev) => {
      const next = new Set(prev);
      next.add(String(id));
      return next;
    });
  }, []);

  const fileInputRef = useRef(null);
  
  const visitPhotoCounts = documents.reduce((counts, document) => {
    const type = String(document.document_type || "");
    counts[type] = (counts[type] || 0) + 1;
    return counts;
  }, {});

  const numarPozePlanAmplasament =
    visitPhotoCounts.poze_plan_amplasament || 0;

  const lipsescPozePlanAmplasament =
    numarPozePlanAmplasament <
    MIN_POZE_PLAN_AMPLASAMENT;
  
  const hasMinimumVisitPhotos = Object.entries(
    MIN_POZE_VIZITA
  ).every(([type, minimum]) => {
    return (visitPhotoCounts[type] || 0) >= minimum;
  });
  
  const hasRequiredContract =
    client?.ctrenergie !== "DA" ||
    documents.some(
      (document) =>
        document.document_type === "contract_energie"
    );
  
  const hasUploadedAllRequiredPhotos =
    hasMinimumVisitPhotos && hasRequiredContract;

  const formatLabel = (value) => {
    return value
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  };

  const getFirmaUserului = (user) => {
    if (!user) return null;
  
    if (user.constanta === "1" || user.constanta === 1) return "FOTONIA";
    if (user.eolos === "1" || user.eolos === 1) return "EOLOS";
    if (user.furgon === "1" || user.furgon === 1) return "FURGON";
    if (user.panelvolt === "1" || user.panelvolt === 1) return "PANEL VOLT SOLAR";
    if (user.marenergy === "1" || user.marenergy === 1) return "MAR ENERGY";
    if (user.redans === "1" || user.redans === 1) return "REDANS";
    if (user.optim === "1" || user.optim === 1) return "OPTIM";
  
    return "Fara firma ";
  };  

  const isFormValid = useMemo(() => {
    return (
      client &&
      String(client.acoperis ?? "").trim() !== "" &&
      /^\d+$/.test(String(client.numar_ape_acoperis ?? "")) &&
      ["Sud", "Est/Vest"].includes(client.expunere_acoperis) &&
      [
        "Pe acoperis",
        "La sol",
        "Ambele",
      ].includes(client.locatie_montaj_sistem_fotovoltaic) &&
      [
        "Pe stalp exterior",
        "Pe gard",
        "Pe casa",
      ].includes(client.locatie_contor) &&
      ["DA", "NU"].includes(
        client.firida_exterioara_trebuie_schimbata
      ) &&
      client.tiptablou &&
      ["DA", "NU"].includes(client.tablou_trebuie_schimbat) &&
      client.impamantare &&
      client.internet &&
      client.secondaryPhone &&
      String(client.email ?? "").trim() !== "" &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        String(client.email ?? "").trim()
      ) &&
      client.ctrenergie &&
      /^\d+$/.test(String(client.suprafata_cladire_construita ?? "")) &&
      /^\d{4}$/.test(String(client.an_constructie_cladire ?? "")) &&
      String(client.material_pereti_casa ?? "").trim() !== "" &&
      /^\d+$/.test(String(client.grosime_pereti_cm ?? "")) &&
      ["DA", "NU"].includes(client.izolatie_pod) &&
      ["DA", "NU"].includes(client.izolatie_pereti) &&
      [
        "Centrala Termica pe Gaz",
        "Centrala Termica pe Lemne",
        "Centrala Termica pe Peleti",
        "Soba",
        "Alte metode de incalzire",
      ].includes(client.sursa_incalzire) &&
      (
        client.sursa_incalzire !==
          "Alte metode de incalzire" ||
        String(
          client.sursa_incalzire_altele ?? ""
        ).trim() !== ""
      ) &&
      hasUploadedAllRequiredPhotos
    );
  }, [client, hasUploadedAllRequiredPhotos]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // 📌 Număr de serii afișate pe pagină

  //  Calculează numărul total de pagini
  const totalPages = Math.ceil(panelSeries.length / itemsPerPage);

  //  Determină ce serii sunt afișate pe pagina curentă
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = panelSeries.slice(indexOfFirstItem, indexOfLastItem);

  const fetchDocuments = useCallback(() => {
    axios
      .get(`https://tj.marenergy.ro/api/get_documents.php?client_id=${id}`)
      .then((response) => {
        if (Array.isArray(response.data)) {
          setDocuments(response.data);
        } else {
          setDocuments([]); // Setează un array gol în loc de `null` sau `undefined`
        }
      })
      .catch(() => {
        console.error("Eroare la incarcarea imaginilor");
        setDocuments([]); // Dacă apare eroare, evităm crash-ul
      });
  }, [id]);

  useEffect(() => {
    if(!user) {
      navigate("/login");
      return;
    }

    axios
      .get(`https://tj.marenergy.ro/api.php?action=get_client&id=${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })

      .then((response) => {
        if (response.data && response.data.id) {
          const acoperisDinBaza = String(response.data.acoperis ?? "").trim();

          setClient({
            ...response.data,
            acoperis: acoperisDinBaza,
            acoperis_selectie: ["Tabla", "Tigla"].includes(acoperisDinBaza)
              ? acoperisDinBaza
              : acoperisDinBaza
              ? "alt_tip"
              : "",
          });
          setSelectedStatus(response.data.status);
          if (["1", "8"].includes(String(response.data.status))) {
            setStatusReason(String(response.data.reason || ""));
          } else {
            setStatusReason("");
          }
          setPanelSeries(response.data.panels || []);
          setAcumulatorSeries(response.data.acumulator_series || []);
          setInvertorSeries(response.data.invertor_series || []);
          setSmartMeterSeries(response.data.smart_meter_series || []);
          setDongleSeries(response.data.dongle_series || []);
          setProsumatorLogs(response.data.prosumator_logs || []);
          setGeneralLogs(response.data.general_logs || []);
          setLastStatusUpdate(response.data.last_status_update || "Nicio actualizare");
          setLastUpdatedBy(response.data.last_updated_by_name || "Necunoscut");
          setIsVisitComplete(response.data.visitComplete === 1 || response.data.visitComplete === "1");
          // ✅ pre-populare câmpuri cartela din DB
          if (response.data.sim_installed === 1 || response.data.sim_installed === "1") {
            setSimInstalled("da");
            setSimOperator(response.data.sim_operator || "");
            setSimIdentifier(response.data.sim_identifier || "");
          } else if (response.data.sim_installed === 0 || response.data.sim_installed === "0") {
            setSimInstalled("nu");
            setSimOperator("");
            setSimIdentifier("");
          } else {
            setSimInstalled(null);
            setSimOperator("");
            setSimIdentifier("");
          }

          // ✅ snapshot SIM din DB (pentru confirmare / blocare)
          const dbSimInstalled =
          response.data.sim_installed === 1 || response.data.sim_installed === "1"
            ? "da"
            : response.data.sim_installed === 0 || response.data.sim_installed === "0"
            ? "nu"
            : null;

          setLastSavedSim({
          simInstalled: dbSimInstalled,
          simOperator: response.data.sim_operator || "",
          simIdentifier: response.data.sim_identifier || "",
          });
        } else {
          setError("Clientul nu a fost găsit");
        }
      })
      .catch(() => setError("Eroare la obținerea datelor despre client"));

    axios
      .get(`https://tj.marenergy.ro/api.php?action=get_prosumator_logs&client_id=${id}`)
      .then((response) => setProsumatorLogs(response.data))
      .catch(() => console.error("Eroare la încărcarea istoricului prosumatorului"));

    axios
      .get(`https://tj.marenergy.ro/api.php?action=get_general_logs&client_id=${id}`)
      .then((response) => setGeneralLogs(response.data))
      .catch(() => console.error("Eroare la încărcarea mesajelor generale"));

    fetchDocuments();
    setSelectedDocumentType("poza_acoperis");
  }, [id, user, navigate, fetchDocuments]);

  useEffect(() => {
    if (!client?.id) return;
  
    setActiveTab("vizita_teren");
  }, [client?.id]);
  
  useEffect(() => {
    if (
      String(client?.i4a) === "1" ||
      String(client?.i4b) === "1" ||
      String(client?.i7) === "1"
    ) {
      setActiveDocTab("executie");
    }
  }, [client]);  

  useEffect(() => {
    if (!user || !client) return;
  
    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];
  
    const hasAssignRights =
      (String(user?.role) === "1" || String(user?.role) === "2") &&
      String(user?.i4b) === "1";
    const canAssign = hasAssignRights && String(client?.i4b) === "1";
  
    const hasAssignRightsI4a = String(user?.role) === "1" && String(user?.i4a) === "1";
    const canAssignI4a = hasAssignRightsI4a && String(client?.i4a) === "1";

    const hasAssignRightsI7 = String(user?.role) === "1" && String(user?.i7) === "1";
    const canAssignI7 = hasAssignRightsI7 && String(client?.i7) === "1";
  
    if (!canAssign && !canAssignI4a && !canAssignI7) return;
  
    let url = "";
  
    if (canAssign) {
      const firmaQuery = firme
        .filter((f) => String(user[f]) === "1")
        .map((f) => `${f}=1`)
        .join("&");
      url = `https://tj.marenergy.ro/api.php?action=get_assignees_i4b&${firmaQuery}`;
    } else if (canAssignI4a) {
      url = `https://tj.marenergy.ro/api.php?action=get_assignees_i4a`;
    } else if (canAssignI7) {
      url = `https://tj.marenergy.ro/api.php?action=get_assignees_i7`;
    }
  
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        if (Array.isArray(res.data)) {
          let filtered = res.data;
  
          if (canAssign) {
            filtered = res.data.filter((assignee) =>
              firme.some(
                (firma) =>
                  String(user[firma]) === "1" &&
                  String(client[firma]) === "1" &&
                  String(assignee[firma]) === "1"
              )
            );
          }

          // 👉 Filtrare: păstrează doar cei care au exact o firmă activă
          filtered = filtered.filter((assignee) => {
            const firmeActive = firme.filter((firma) => String(assignee[firma]) === "1");
            return firmeActive.length === 1;
          });
  
          setAvailableAssignees(filtered);
        }
      })
      .catch(() =>
        console.error("Eroare la incarcarea utilizatorilor disponibili pentru atribuire")
      );
  }, [user, client]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  useEffect(() => {
    if (!isMobile) return;
  
    const handleClickOutside = (e) => {
      const clickedTooltip = e.target.closest(".doc-tooltip");
      const clickedIcon = e.target.closest(".missing-doc-icon");
  
      // Nu închide dacă am făcut click pe iconă (pentru că tocmai vrem să-l deschidem)
      if (!clickedTooltip && !clickedIcon) {
        setShowTooltip(false);
      }
    };
  
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile]);
  
  useEffect(() => {
    if (isChangingStatus) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [isChangingStatus]);
  

  const handleSaveVisitData = () => {
    axios.post("https://tj.marenergy.ro/api.php", {
      action: "save_visit_data",
      client_id: id,
      acoperis: String(client?.acoperis ?? "").trim(),
      numar_ape_acoperis: client?.numar_ape_acoperis,
      expunere_acoperis: client?.expunere_acoperis,
      locatie_montaj_sistem_fotovoltaic: client?.locatie_montaj_sistem_fotovoltaic,
      internet: client?.internet,
      bransament: client?.bransament,
      locatie_contor: client?.locatie_contor,
      firida_exterioara_trebuie_schimbata: client?.firida_exterioara_trebuie_schimbata,
      tiptablou: client?.tiptablou,
      tablou_trebuie_schimbat: client?.tablou_trebuie_schimbat,
      impamantare: client?.impamantare,
      secondaryPhone: client?.secondaryPhone,
      email: String(client?.email ?? "").trim(),
      notes: client?.notes,
      ctrenergie: client?.ctrenergie,
      suprafata_cladire_construita: client?.suprafata_cladire_construita,
      an_constructie_cladire: client?.an_constructie_cladire,
      material_pereti_casa: client?.material_pereti_casa,
      grosime_pereti_cm: client?.grosime_pereti_cm,
      izolatie_pod: client?.izolatie_pod,
      izolatie_pereti: client?.izolatie_pereti,
      sursa_incalzire: client?.sursa_incalzire, 
      sursa_incalzire_altele: client?.sursa_incalzire === "Alte metode de incalzire" ? client?.sursa_incalzire_altele : "",
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
    .then((response) => {
      alert("Datele au fost salvate cu succes!");
      setIsVisitComplete(response.data.visitComplete === 1);
      setIsEditing(false);
  
      const actionMessage = isEditing
      ? `${user?.name} a editat informatiile din vizita de teren pentru clientul ${client?.name}`
      : `${user?.name} a finalizat vizita de teren pentru clientul ${client?.name}`;
    
      const generalMessage = isEditing
      ? `Vizita de teren a fost editata pentru ${client?.name} de catre ${user?.name}`
      : `Vizita de teren a fost finalizata pentru ${client?.name} de catre ${user?.name}`;

      return Promise.all([
        axios.post("https://tj.marenergy.ro/api.php", {
          action: "add_general_log",
          client_id: id,
          message: generalMessage,
          //user_id: user?.user_id,
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),

        axios.post("https://tj.marenergy.ro/api.php", {
          action: "add_visit_log",
          client_id: id,
          message: actionMessage,
          //user_id: user?.user_id,
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
      ]);
    })
    .then(() => {
      // 🔹 Actualizăm statusul clientului în "2" (Lucrări active)
      return axios.post("https://tj.marenergy.ro/api.php", {
        action: "update_status",
        client_id: id,
        status: 2,
        //user_id: user?.user_id,
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
    })
    .then(() => {
      // ✅ REFRESH PAGINĂ după toate salvările
      setTimeout(() => {
        window.location.reload();
      }, 500);
    })
    .catch(() => alert("Eroare la salvarea datelor! E: 01"));
  };  

  const handleChangeStatus = () => {
    if (!user || !user.user_id) {
      console.error("❌ Eroare: user_id lipsă");
      return;
    }

    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

    if (!isExemptUser && client?.i4b === "1" && client?.i4a !== "1" && client?.i7 !== "1") {
      const firmeUser = firme.filter(firma => String(user?.[firma]) === "1");
      const firmeClient = firme.filter(firma => String(client?.[firma]) === "1");
    
      const firmeComune = firmeUser.filter(firma => firmeClient.includes(firma));
    
      // Permitem doar dacă userul și clientul au fiecare exact o firmă, și este aceeași
      const arePermisiuneFirma =
        firmeUser.length === 1 &&
        firmeClient.length === 1 &&
        firmeComune.length === 1;
    
      if (!arePermisiuneFirma) {
        alert("⛔ Nu aveti permisiunea sa faceti modificari pentru acest client.");
        return;
      }
    }

    // înainte de a porni requestul
    if (String(client?.status) === "2" && String(selectedStatus) === "3") {
      // i4a sau i7: panoul e obligatoriu
      if (!areTipPanouInDB && !tipPanouSelectat && (String(client?.i4a) === "1" || String(client?.i7) === "1")) {
        alert("Selectează tipul panoului înainte de a finaliza montajul (status 3).");
        return;
      }
    
      // DOAR i4a: acumulatorul e obligatoriu
      if (String(client?.i4a) === "1" && !areTipAcumulatorInDB && !tipAcumulatorSelectat) {
        alert("Selectează tipul acumulatorului înainte de a finaliza montajul (status 3).");
        return;
      }
    
      // i4a și i7: invertorul e obligatoriu
      if (!areTipInvertorInDB && !tipInvertorSelectat && (String(client?.i4a) === "1" || String(client?.i7) === "1")) {
        alert("Selectează tipul invertorului înainte de a finaliza montajul (status 3).");
        return;
      }
    }
    
    // ✅ SIM (cartela) — obligatoriu să alegi DA/NU doar când treci din Activ(2) -> Montaj finalizat(3)
    if (String(client?.status) === "2" && String(selectedStatus) === "3") {
      // 1) Trebuie bifat DA sau NU
      if (simInstalled !== "da" && simInstalled !== "nu") {
        alert("⚠️ Trebuie sa bifezi daca ati instalat cartela la beneficiar: DA sau NU.");
        return;
      }

      // 2) Dacă e DA -> operator + identificare obligatorii
      if (simInstalled === "da") {
        if (!simOperator) {
          alert("Selecteaza Operatorul (Orange/Digi/Vodafone) inainte de a finaliza montajul.");
          return;
        }
        if (!simIdentifier || simIdentifier.trim().length === 0) {
          alert("Completeaza Identificare cartela înainte de a finaliza montajul.");
          return;
        }
        if (simIdentifier.length > 30) {
          alert("Identificare cartela trebuie să aiba max 30 caractere.");
          return;
        }
      }
    }    

    if (selectedStatus === client?.status) {
      alert("⚠️ Statusul este deja setat la aceasta valoare. Va rugam sa alegeti un status diferit.");
      return;
    }
    
    const isI4a = String(client?.i4a) === "1";
    const isI7  = String(client?.i7)  === "1";
    const isI4b = String(client?.i4b) === "1";
    
    // NU aplica regulile de mai jos dacă treci în status 1 sau 8
    const skipHardwareChecks = ["1", "8"].includes(String(selectedStatus));
    
    if (!skipHardwareChecks) {
      if ((isI4a || isI7) && panelSeries.length < 5) {
        alert("⚠️ Trebuie sa adaugi seriile panourilor fotovoltaice inainte sa schimbi statusul clientului!");
        return;
      }
    
      if ((isI4b || isI4a) && acumulatorSeries.length === 0) {
        alert("⚠️ Trebuie sa adaugati cel putin o serie de acumulatori inainte de a schimba statusul clientului!");
        return;
      }
    
      if ((isI4a || isI7) && invertorSeries.length === 0) {
        alert("⚠️ Trebuie sa adaugati cel putin o serie de invertor inainte de a schimba statusul clientului!");
        return;
      }
    
      if ((isI4a || isI7) && smartMeterSeries.length === 0) {
        alert("⚠️ Trebuie să adăugați cel puțin o serie de smart-meter înainte de a schimba statusul clientului!");
        return;
      }
    
      if ((isI4a || isI7) && DongleSeries.length === 0) {
        alert("⚠️ Trebuie să adăugați cel puțin o serie dongle 4G înainte de a schimba statusul clientului!");
        return;
      }

      const hasGroundingPhoto = documents.some(doc => doc.document_type === "priza_pamant");
      if (!hasGroundingPhoto) {
        alert("Trebuie sa incarcati o poza cu priza de pamant inainte de a schimba statusul clientului!");
        return;
      }
      
    }

    if ((selectedStatus === "1" || selectedStatus === "8") && statusReason.trim() === "") {
      alert("⚠️ Trebuie sa specifici un motiv pentru trecerea in acest status!");
      return;
    }    

    if (selectedStatus === "5") {
      const hasCertificate = documents.some(doc => doc.document_type === "certificat_racordare");
      if (!hasCertificate) {
        alert("Trebuie sa incarcati certificatul de racordare pentru a putea seta statusul la 'Certificat de Racordare'!");
        return;
      }
    }

    if (selectedStatus === "5") {
      alert("⛔ Momentan nu este permis sa schimbi statusul in 'Certificat de Racordare'.");
      return;
    }
    
    if (String(client?.status) === "7") {
      alert("⛔ Clientul este depus la MIPE (status 7) si nu mai poate fi schimbat in alt status.");
      return;
    }

    if (String(client?.status) === "4" && !["5", "7"].includes(String(selectedStatus))) {
      alert("⛔ Din statusul Dosar Prosumator poti trece doar in status C.F.R. sau Depus MIPE.");
      return;
    }

    // ❗ Pentru status 7 factura_voucher este obligatorie DOAR pentru i4a, nu pentru i7
    if (String(selectedStatus) === "7") {
      const isI4A = String(client?.i4a) === "1";
      const isI7 = String(client?.i7) === "1";

      if (isI4A && !isI7) {
        const hasVoucherInvoice = documents.some(doc => doc.document_type === "factura_voucher");
        if (!hasVoucherInvoice) {
          alert("⛔ Pentru a putea seta statusul 'Depus la MIPE (7)', trebuie sa incarcati documentul 'Factura Voucher'.");
          return;
        }
      }
    }

    if (selectedStatus === "4") {
      let requiredDocs = [];
    
      if (client?.i4a === "1") {
        requiredDocs = [
          "dovada_prosumator",
          "proces_verbal_fotovoltaice",
          "proces_verbal_stocare"
        ];
      } else if (client?.i4b === "1") {
        requiredDocs = [
          "dovada_prosumator",
          "proces_verbal"
        ];
      } else if (client?.i7 === "1") {
        const hasDovadaI7 =
          documents.some(doc =>
            doc.document_type === "dovada_prosumator_1" ||
            doc.document_type === "dovada_prosumator_2"
          );
      
        const hasPVI7 = documents.some(
          doc => doc.document_type === "proces_verbal_fotovoltaice"
        );
      
        if (!hasDovadaI7 || !hasPVI7) {
          alert(
            "⚠️ Pentru i7 este obligatoriu Procesul Verbal Fotovoltaice si una dintre dovezile de prosumator (1 sau 2)."
          );
          return;
        }
      }      
    
      const hasAllRequiredDocs = requiredDocs.every((type) =>
        documents.some((doc) => doc.document_type === type)
      );
    
      if (!hasAllRequiredDocs) {
        alert(
          "⚠️ Trebuie sa incarci toate documentele/pozele obligatorii pentru acest status."
        );
        return;
      }
    }    

    if (selectedStatus === "3") {
      // Documentele de bază necesare pentru status 3
      const executieDocs = [
        "poza_client_inainte",
        "priza_pamant",
        "poza_tablou_dupa",
        "poza_acumulatori_si_invertor"
      ];
    
      // Doar dacă clientul este i4b, adaugă și pozele suplimentare
      if (client?.i4a === "1" || client?.i7 === "1") {
        executieDocs.push("poza_acoperis_dupa", "poza_casa_dupa");
      }
    
      const hasAllExecutieDocs = executieDocs.every(type =>
        documents.some(doc => doc.document_type === type)
      );
    
      if (!hasAllExecutieDocs) {
        alert("⚠️ Pentru a seta statusul la 'Montaje Finalizate', trebuie sa incarci toate documentele de executie necesare.");
        return;
      }

      const docCount = documents.reduce((acc, doc) => {
        const k = String(doc.document_type);
        acc[k] = (acc[k] || 0) + 1;
        return acc;
      }, {});
    
      const MIN_POZE = {
        poza_client_inainte: 5,
        poza_acumulatori_si_invertor: 4,
        poza_acoperis_dupa: 2,
        poza_casa_dupa: 2,
      };
      
      const insuficiente = Object.entries(MIN_POZE)
        .filter(([type, min]) => (docCount[type] || 0) < min)
        .map(
          ([type, min]) =>
            `${type.replaceAll("_", " ")} (minim ${min}, ai ${docCount[type] || 0})`
        );
      
      if (insuficiente.length) {
        alert(
          "⚠️ Pentru a seta statusul la 'Montaj finalizat', trebuie sa ai suficiente poze:\n" +
            " - " +
            insuficiente.join("\n - ")
        );
        return;
      }      
    } 

    if (selectedStatus === "3") {    
      // 🔒 NOU: Pentru i4a / i7 trebuie ambele PV-uri încarcate în DB
      if (client?.i4a === "1") {
        const hasPV_FV = documents.some((d) => d.document_type === "proces_verbal_fotovoltaice");
        const hasPV_ST = documents.some((d) => d.document_type === "proces_verbal_stocare");
    
        if (!hasPV_FV || !hasPV_ST) {
          alert("⛔ Nu poti seta 'Montaj finalizat' fara ambele procese verbale: Fotovoltaice si Stocare.");
          return;
        }
      }

      if (client?.i7 === "1") {
        const hasPV_FV = documents.some((d) => d.document_type === "proces_verbal_fotovoltaice");
    
        if (!hasPV_FV) {
          alert("⛔ Nu poti seta 'Montaj finalizat' fara procesul verbal semnat si incarcat.");
          return;
        }
      }

    }    
    
    // 🔒 Dacă clientul este i4b și userul are rol 3 → trebuie să fie atribuit explicit
    if (
      client?.i4b === "1" &&
      String(user?.role) === "3" &&
      String(client?.assigned_to) !== String(user?.user_id)
    ) {
      alert("⛔ Nu poti modifica statusul pentru acest client. Lucrarea nu ti-a fost atribuita.");
      return;
    }

    setIsChangingStatus(true);
    
    axios.post(
      "https://tj.marenergy.ro/api.php",
      {
        action: "update_status",
        client_id: id,
        status: selectedStatus,
        user_id: user.user_id,
        reason: ["1", "8"].includes(String(selectedStatus)) ? statusReason : null,
        sim_installed: simInstalled === "da" ? 1 : simInstalled === "nu" ? 0 : null,
        sim_operator: simInstalled === "da" ? simOperator : null,
        sim_identifier: simInstalled === "da" ? simIdentifier : null,
        // (opțional) dacă vrei să persiști tipurile la 2→3 prin acest request:
        // tippanou: tipPanouSelectat || client?.tippanou || "",
        // tipacumulator: tipAcumulatorSelectat || client?.tipacumulator || "",
        // tipinvertor: tipInvertorSelectat || client?.tipinvertor || "",
      },
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    )
    .then((response) => {
      alert(response.data.message);
  
      // ✅ Actualizezi statusul local
      setClient((prev) => ({
        ...prev,
        status: selectedStatus,
        assigned_to: response?.data?.assigned_to ?? prev.assigned_to,
        assigned_to_name: response?.data?.assigned_to_name ?? prev.assigned_to_name,
      }));
  
      const currentTime = new Date().toLocaleString();
      setLastStatusUpdate(currentTime);
      setLastUpdatedBy(user.name);
    })
    .catch(() => {
      alert("Eroare la actualizarea statusului");
    })
    .finally(() => {
      setIsChangingStatus(false);
    });    
  };

  const getMissingDocuments = () => {
    if (!selectedStatus) return [];
  
    const missing = [];
  
    const has = (type) => documents.some(doc => doc.document_type === type);
  
    if (selectedStatus === "3") {
      const base = [
        "poza_client_inainte",
        "priza_pamant",
        "poza_tablou_dupa",
        "poza_acumulatori_si_invertor"
      ];
      if (client?.i4a === "1" || client?.i7 === "1") {
        base.push("poza_acoperis_dupa", "poza_casa_dupa");
      }
      base.forEach(type => {
        if (!has(type)) missing.push(formatLabel(type));
      });

      if (client?.i4a === "1") {
        if (!has("proces_verbal_fotovoltaice")) missing.push("Proces Verbal Fotovoltaice");
        if (!has("proces_verbal_stocare")) missing.push("Proces Verbal Stocare");
      }
      if (client?.i7 === "1") {
        if (!has("proces_verbal_fotovoltaice")) missing.push("Proces Verbal Fotovoltaice");
      }

      // ✅ SIM (cartela) — apare la ❗ doar când vrem 2 -> 3
      if (String(client?.status) === "2") {
        // dacă nu e ales DA/NU
        if (simInstalled !== "da" && simInstalled !== "nu") {
          missing.push("Cartela instalata la beneficiar? (Da/Nu)");
        }

        // dacă e DA, devin obligatorii și astea
        if (simInstalled === "da") {
          if (!simOperator) missing.push("Operator (Orange/Digi/Vodafone)");
          if (!simIdentifier || !simIdentifier.trim()) missing.push("Identificare cartela");
          if (simIdentifier && simIdentifier.length > 30) missing.push("Identificare cartela (max 30 caractere)");
        }
      }
    }
  
    if (selectedStatus === "4") {
      //const requiredDocsI7 = ["dovada_prosumator_2", "proces_verbal_fotovoltaice"];
      const requiredDocsI4a = ["dovada_prosumator", "proces_verbal_fotovoltaice", "proces_verbal_stocare"];
      const requiredDocsI4b = ["dovada_prosumator", "proces_verbal"];
    
      let required = [];
      //if (client?.i7 === "1") required.push(...requiredDocsI7);
      if (client?.i4a === "1") required.push(...requiredDocsI4a);
      if (client?.i4b === "1") required.push(...requiredDocsI4b);

      // i7: PV obligatoriu + (dovada_1 OR dovada_2)
      if (client?.i7 === "1") {
        if (!has("proces_verbal_fotovoltaice")) {
          missing.push("Proces Verbal Fotovoltaice");
        }

        const hasDovadaI7 = has("dovada_prosumator_1") || has("dovada_prosumator_2");
        if (!hasDovadaI7) {
          missing.push("Dovada Prosumator (1 sau 2)");
        }
      }
    
      required = [...new Set(required)];
      required.forEach(type => {
        if (!has(type)) missing.push(formatLabel(type));
      });
    }    
  
    if (selectedStatus === "5" && !has("certificat_racordare")) {
      missing.push("Certificat Racordare");
    }

    if (selectedStatus === "7") {
      const isI4A = String(client?.i4a) === "1";
      const isI7 = String(client?.i7) === "1";
    
      if (isI4A && !isI7 && !has("factura_voucher")) {
        missing.push("Factura Voucher");
      }
    }       
  
    return missing;
  };
  
  // ——— Flow PV per tip (FV / ST) ———
  const [isGeneratingPV, setIsGeneratingPV] = useState(false);
  const [pvGeneratedFor, setPvGeneratedFor] = useState(null); // string: tipul pentru care s-a generat
  const [pvDownloadUrl, setPvDownloadUrl] = useState("");      // url relativ/absolut pt un singur PDF
  const [pvDownloadedFor, setPvDownloadedFor] = useState(null); // tipul pentru care s-a făcut download

  useEffect(() => {
    setPvGeneratedFor(null);
    setPvDownloadUrl("");
    setPvDownloadedFor(null);
  }, [selectedDocumentType]);

  const hasDocType = useCallback((type) => {
    return documents.some(d => String(d.document_type) === String(type));
  }, [documents]);

  const getDocCountMap = useCallback(() => {
    return documents.reduce((acc, doc) => {
      const k = String(doc.document_type || "");
      acc[k] = (acc[k] || 0) + 1;
      return acc;
    }, {});
  }, [documents]);
  
  const validatePvPreconditions = useCallback((docType) => {
    const isI4a = String(client?.i4a) === "1";
    const isI7  = String(client?.i7) === "1";
    const isFV  = docType === "proces_verbal_fotovoltaice";
    const isST  = docType === "proces_verbal_stocare";
  
    // 1️⃣ Seriile minime
    if ((isI4a || isI7) && panelSeries.length < 5) {
      alert("⚠️ Trebuie să ai minim 5 serii de panouri fotovoltaice înainte de a genera P.V.");
      return false;
    }
    if (isI4a && acumulatorSeries.length < 1) {
      alert("⚠️ Trebuie să adaugi cel puțin o serie de acumulator (i4a).");
      return false;
    }
    if (invertorSeries.length < 1) {
      alert("⚠️ Trebuie să adaugi cel puțin o serie de invertor.");
      return false;
    }
    if ((isI4a || isI7) && smartMeterSeries.length < 1) {
      alert("⚠️ Trebuie să adaugi cel puțin o serie de Smart Meter.");
      return false;
    }
    if ((isI4a || isI7) && DongleSeries.length < 1) {
      alert("⚠️ Trebuie să adaugi cel puțin o serie de Dongle 4G.");
      return false;
    }
  
    // 2️⃣ Tipurile salvate în baza de date
    if (!client?.tippanou) {
      alert("⚠️ Selectează și salvează TIPUL PANOURILOR înainte de generarea P.V.");
      return false;
    }
    if (!client?.tipinvertor) {
      alert("⚠️ Selectează și salvează TIPUL INVERTORULUI înainte de generarea P.V.");
      return false;
    }
    if (isI4a && !client?.tipacumulator) {
      alert("⚠️ Selectează și salvează TIPUL ACUMULATORULUI înainte de generarea P.V.");
      return false;
    }
  
    // 3️⃣ Verifică pozele necesare
    const docCount = getDocCountMap();
    const MIN_POZE = {
      poza_client_inainte: 5,
      poza_acumulatori_si_invertor: 4,
      poza_acoperis_dupa: 2,
      poza_casa_dupa: 2,
    };
  
    // FV -> toate; ST -> doar pozele cu acumulator/invertor
    let requiredForThisPV = {};
    if (isFV) {
      requiredForThisPV = { ...MIN_POZE };
    } else if (isST) {
      requiredForThisPV = {
        poza_acumulatori_si_invertor: MIN_POZE.poza_acumulatori_si_invertor,
      };
    }
  
    // pentru i4b (doar baterii) nu cerem acoperis/casa
    if (!(isI4a || isI7)) {
      delete requiredForThisPV.poza_acoperis_dupa;
      delete requiredForThisPV.poza_casa_dupa;
    }
  
    const lipsuri = Object.entries(requiredForThisPV)
      .filter(([type, min]) => (docCount[type] || 0) < min)
      .map(([type, min]) => `${type.replaceAll("_", " ")} (minim ${min}, ai ${docCount[type] || 0})`);
  
    if (lipsuri.length) {
      alert("⚠️ Nu poți genera P.V. — lipsesc poze suficiente:\n - " + lipsuri.join("\n - "));
      return false;
    }
  
    return true;
  }, [
    client?.i4a,
    client?.i7,
    client?.tippanou,
    client?.tipinvertor,
    client?.tipacumulator,
    panelSeries.length,
    acumulatorSeries.length,
    invertorSeries.length,
    smartMeterSeries.length,
    DongleSeries.length,
    getDocCountMap,
  ]);  
  
  const handleGeneratePV = async () => {
    // ✅ validăm condițiile
    if (!validatePvPreconditions(selectedDocumentType)) return;

    const isFV = selectedDocumentType === "proces_verbal_fotovoltaice";
    const label = isFV ? "procesul verbal de recepție FV" : "procesul verbal de recepție Stocare";
    if (!window.confirm(`Ești sigur că vrei să generezi ${label}?`)) return;
  
    setIsGeneratingPV(true);
    try {
      const res = await axios.post(
        "https://tj.marenergy.ro/api.php",
        {
          action: "generate_pv_single",
          client_id: id,
          docType: selectedDocumentType,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
  
      const file = res.data?.url;
      if (!file) {
        alert("Nu s-a putut genera PDF-ul.");
        return;
      }
  
      setPvDownloadUrl(file);
      setPvGeneratedFor(selectedDocumentType);
    } catch (e) {
      alert(e?.response?.data?.message || "Eroare la generarea procesului verbal.");
    } finally {
      setIsGeneratingPV(false);
    }
  };  
  
  const handleDownloadPV = () => {
    if (!pvDownloadUrl) return;
    const fullUrl = pvDownloadUrl.startsWith("http")
      ? pvDownloadUrl
      : `https://tj.marenergy.ro${pvDownloadUrl}`;
    window.open(fullUrl, "_blank", "noopener,noreferrer");
    setPvDownloadedFor(selectedDocumentType);
  };
  
  useEffect(() => {
    const isI4AI7 = String(client?.i4a) === "1" || String(client?.i7) === "1";
    const isPV = ["proces_verbal_fotovoltaice", "proces_verbal_stocare"].includes(selectedDocumentType);
    if (!isI4AI7 || !isPV) return;
  
    axios
      .get(`https://tj.marenergy.ro/api.php?action=get_pv_status&client_id=${id}&docType=${selectedDocumentType}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(res => {
        if (res.data?.exists && res.data?.url) {
          setPvDownloadUrl(res.data.url);
          setPvGeneratedFor(selectedDocumentType);
        }
      })
      .catch(() => {});
  }, [selectedDocumentType, id, client]);  

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleContractFileChange = (event) => {
    setSelectedContractFile(event.target.files[0]);
  };  

  const handleUpload = () => {
    if (!selectedFile) {
      alert("Selectati un fisier!");
      return;
    }

    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

    // Aplica restricție doar dacă clientul este exclusiv i4b
    if (!isExemptUser && client?.i4b === "1" && client?.i4a !== "1" && client?.i7 !== "1") {
      const firmeUser = firme.filter(firma => String(user?.[firma]) === "1");
      const firmeClient = firme.filter(firma => String(client?.[firma]) === "1");
    
      const firmeComune = firmeUser.filter(firma => firmeClient.includes(firma));
    
      // Permitem doar dacă userul și clientul au fiecare exact o firmă, și este aceeași
      const arePermisiuneFirma =
        firmeUser.length === 1 &&
        firmeClient.length === 1 &&
        firmeComune.length === 1;
    
      if (!arePermisiuneFirma) {
        alert("⛔ Nu aveți permisiunea să faceți modificări pentru acest client.");
        return;
      }
    }

    if (
      client?.i4b === "1" &&
      String(user?.role) === "3" &&
      String(client?.assigned_to) !== String(user?.user_id) &&
      !isExemptUser
    ) {
      alert("⛔ Nu poti incarca documente pentru acest client. Lucrarea nu ti-a fost atribuita.");
      return;
    }

    // Validare pentru planul de amplasament
    const fileExtension = selectedFile.name
      .split(".")
      .pop()
      .toLowerCase();

    if (
      selectedDocumentType === "poze_plan_amplasament" &&
      !["pdf", "jpg", "jpeg", "png"].includes(fileExtension)
    ) {
      alert(
        "Pentru planul de amplasament sunt permise doar PDF, JPG, JPEG și PNG."
      );
      return;
    }
  
    if (selectedFile.size > 30 * 1024 * 1024) {
      alert("Fisierul este prea mare! (maxim 30MB)");
      return;
    }
  
    // 🚨 Verificăm dacă există deja un certificat de racordare pentru acest client
    if (selectedDocumentType === "certificat_racordare" && documents.some(doc => doc.document_type === "certificat_racordare")) {
      alert("Exista deja un Certificat de Racordare incarcat pentru acest client!");
      return;
    }

    if (selectedDocumentType === "factura_voucher" && documents.some(doc => doc.document_type === "factura_voucher")) {
      alert("Exista deja o factura voucher incarcata pentru acest client!");
      return;
    }

    if (selectedDocumentType === "factura_delgaz" && documents.some(doc => doc.document_type === "factura_delgaz")) {
      alert("Exista deja o factura delgaz incarcata pentru acest client!");
      return;
    }

    if (selectedDocumentType === "dovada_delgaz" && documents.some(doc => doc.document_type === "dovada_delgaz")) {
      alert("Exista deja o dovada delgaz incarcata pentru acest client!");
      return;
    }
  
    const currentTime = Date.now();
    if (currentTime - lastUploadTime < 5000) { // Restricție de 5 secunde
      alert("Asteptati 5 secunde inainte de a incarca alt fisier!");
      return;
    }
  
    setIsUploading(true);
  
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("client_id", id);
    formData.append("document_type", selectedDocumentType); // Trimitem tipul documentului
  
    axios
      .post("https://tj.marenergy.ro/api/upload.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        alert(response.data.message);
        setLastUploadTime(currentTime);
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        fetchDocuments(); // 🔄 reîncarcă lista
      })
      .catch((error) => {
        console.error("Eroare la incarcare:", error);
        alert(error.response?.data?.message || "Eroare la incarcare");
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const handleUploadContract = () => {
    if (!selectedContractFile) {
      alert("Selectați un fisier!");
      return;
    }
  
    const fileExtension = selectedContractFile.name.split(".").pop().toLowerCase();
    if (fileExtension !== "pdf") {
      alert("Tip de fișier invalid! Se permite doar format PDF pentru Contract Energie.");
      return;
    }
  
    // Verificăm dacă există deja un contract încărcat pentru acest client
    if (documents.some(doc => doc.document_type === "contract_energie")) {
      alert("Exista deja un Contract Energie încarcat pentru acest client!");
      return;
    }

    // Verificăm dimensiunea fișierului
    if (selectedContractFile.size > 30 * 1024 * 1024) {
      alert("Fisierul este prea mare! (maxim 30MB)");
      return;
    }

    // Verificăm restricția de timp de 10 secunde
    const currentTime = Date.now();
    if (currentTime - lastUploadTime < 10000) {
      alert("Asteptti 10 secunde inainte de a incarca alt fisier!");
      return;
    }
  
    setIsContractUploading(true);
  
    const formData = new FormData();
    formData.append("file", selectedContractFile);
    formData.append("client_id", id);
    formData.append("document_type", "contract_energie");
  
    axios
      .post("https://tj.marenergy.ro/api/upload.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        alert(response.data.message);
        setSelectedContractFile(null);
        if (contractFileInputRef.current) contractFileInputRef.current.value = "";
        fetchDocuments(); // Reîncarcă lista documentelor
      })
      .catch((error) => {
        console.error("Eroare la încărcare:", error);
        alert(error.response?.data?.message || "Eroare la incarcare");
      })
      .finally(() => {
        setIsContractUploading(false);
      });
  };  

  const handleDownloadExcel = () => {
    if (!client) {
      alert("Clientul nu este definit.");
      return;
    }
  
    if (
      panelSeries.length === 0 &&
      acumulatorSeries.length === 0 &&
      invertorSeries.length === 0 &&
      smartMeterSeries.length === 0 &&
      DongleSeries.length === 0
    ) {
      alert("Nu exista serii pentru a fi descarcate.");
      return;
    }
  
    // Generalized mapping function
    const buildDataWithType = (seriesArray, type, key) =>
      seriesArray.map((item) => ({
        TipSerie: type,
        Serie: item[key],
      }));
  
    const allSeriesData = [
      ...buildDataWithType(panelSeries, "Panou", "series"),
      ...buildDataWithType(acumulatorSeries, "Acumulator", "series"),
      ...buildDataWithType(invertorSeries, "Invertor", "series_invertor"),
      ...buildDataWithType(smartMeterSeries, "SmartMeter", "series_smart_meter"),
      ...buildDataWithType(DongleSeries, "Dongle", "series_dongle"),
    ].map((item, index) => ({
      Nr: index + 1,
      ...item,
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(allSeriesData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Serii");
  
    const fileName = `serii_${client.name.replace(/\s+/g, "_")}.xlsx`;
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, fileName);
  };

  const handleAddPanelSeries = () => {
    if (newPanel.trim() === "") {
      alert("Introduceți o serie validă!");
      return;
    }

    const sanitizedSeries = validateSeriesInput(
      newPanel,
      panelSeries.map((item) => item.series),
      "panouri"
    );
    
    if (!sanitizedSeries) {
      return;
    }

    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

    // Aplica restricție doar dacă clientul este exclusiv i4b
    if (client?.i4b === "1" && client?.i4a !== "1" && client?.i7 !== "1") {
      const firmeUser = firme.filter(firma => String(user?.[firma]) === "1");
      const firmeClient = firme.filter(firma => String(client?.[firma]) === "1");
    
      const firmeComune = firmeUser.filter(firma => firmeClient.includes(firma));
    
      // Permitem doar dacă userul și clientul au fiecare exact o firmă, și este aceeași
      const arePermisiuneFirma =
        firmeUser.length === 1 &&
        firmeClient.length === 1 &&
        firmeComune.length === 1;
    
      if (!arePermisiuneFirma) {
        alert("⛔ Nu aveți permisiunea să faceți modificări pentru acest client.");
        return;
      }
    }
    
    if (
      client?.i4b === "1" &&
      String(user?.role) === "3" &&
      String(client?.assigned_to) !== String(user?.user_id)
    ) {
      alert("⛔ Nu poti adauga serii pentru acest client. Lucrarea nu ti-a fost atribuita.");
      return;
    }

    // ⏳ Verificăm dacă au trecut 5 secunde de la ultima adăugare
    const currentTime = Date.now();
    if (currentTime - lastPanelAddTime < 2000) { // 2000 ms = 2 secunde
      alert("Asteapta 2 secunde inainte de a adauga o noua serie!");
      return;
    }

    setIsAddingPanel(true); // 🔹 start loading
    axios
      .post(
        "https://tj.marenergy.ro/api.php",
        {
          action: "add_panel_series",
          client_id: id,
          series: sanitizedSeries,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        setPanelSeries([{ id: Date.now(), series: sanitizedSeries }, ...panelSeries]);
        setNewPanel("");
        setLastPanelAddTime(currentTime);
        // 🔹 ping vizual 1.2s
        setPanelAddedPing(true);
        setTimeout(() => setPanelAddedPing(false), 1200);
      })
      .catch((err) => {
        alert(err?.response?.data?.message || "Eroare la adaugarea seriei. Exista deja in baza de date sau ati depasit limita de caractere.");
      })
      .finally(() => setIsAddingPanel(false));
  };

  const handleAddAcumulatorSeries = () => {
    const sanitizedSeries = validateSeriesInput(
      newAcumulator,
      acumulatorSeries.map((item) => item.series),
      "acumulatori"
    );
    
    if (!sanitizedSeries) {
      return;
    }

    // 🔒 Verificare firmă: user trebuie să aparțină aceleiași firme ca și clientul
    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

    // Aplica restricție doar dacă clientul este exclusiv i4b
    if (client?.i4b === "1" && client?.i4a !== "1" && client?.i7 !== "1") {
      const firmeUser = firme.filter(firma => String(user?.[firma]) === "1");
      const firmeClient = firme.filter(firma => String(client?.[firma]) === "1");
    
      const firmeComune = firmeUser.filter(firma => firmeClient.includes(firma));
    
      // Permitem doar dacă userul și clientul au fiecare exact o firmă, și este aceeași
      const arePermisiuneFirma =
        firmeUser.length === 1 &&
        firmeClient.length === 1 &&
        firmeComune.length === 1;
    
      if (!arePermisiuneFirma) {
        alert("⛔ Nu aveți permisiunea să faceți modificări pentru acest client.");
        return;
      }
    }
    
    if (
      client?.i4b === "1" &&
      String(user?.role) === "3" &&
      String(client?.assigned_to) !== String(user?.user_id)
    ) {
      alert("⛔ Nu poti adauga serii pentru acest client. Lucrarea nu ti-a fost atribuita.");
      return;
    }
  
    const currentTime = Date.now();
    if (currentTime - lastAcumulatorAddTime < 2000) { // 2 secunde
      alert("Așteptați 2 secunde înainte de a adăuga o nouă serie de acumulator!");
      return;
    }
  
    setIsAddingAcumulator(true); // 🔹 start loading
    axios
      .post(
        "https://tj.marenergy.ro/api.php",
        {
          action: "add_acumulator_series",
          client_id: id,
          series_acumulator: sanitizedSeries,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        setAcumulatorSeries([{ id: Date.now(), series: sanitizedSeries }, ...acumulatorSeries]);
        setNewAcumulator("");
        setLastAcumulatorAddTime(currentTime);

        // 🔹 ping vizual ~1.2s
        setAcumulatorAddedPing(true);
        setTimeout(() => setAcumulatorAddedPing(false), 1200);
      })
      .catch((err) => {
        alert(err?.response?.data?.message || "Eroare la adaugarea seriei acumulatorului. Exista deja in baza de date sau ati depasit limita de caractere.");
      })
      .finally(() => setIsAddingAcumulator(false)); 
  };  

  const handleAddInvertorSeries = () => {
    const sanitizedSeries = validateSeriesInput(
      newInvertor,
      invertorSeries.map(item => item.series_invertor),
      "invertoare"
    );
    
    if (!sanitizedSeries) {
      return;
    }

      // 🔒 Verificare firmă: user trebuie să aparțină aceleiași firme ca și clientul
    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

    // Aplica restricție doar dacă clientul este exclusiv i4b
    if (client?.i4b === "1" && client?.i4a !== "1" && client?.i7 !== "1") {
      const firmeUser = firme.filter(firma => String(user?.[firma]) === "1");
      const firmeClient = firme.filter(firma => String(client?.[firma]) === "1");
    
      const firmeComune = firmeUser.filter(firma => firmeClient.includes(firma));
    
      // Permitem doar dacă userul și clientul au fiecare exact o firmă, și este aceeași
      const arePermisiuneFirma =
        firmeUser.length === 1 &&
        firmeClient.length === 1 &&
        firmeComune.length === 1;
    
      if (!arePermisiuneFirma) {
        alert("⛔ Nu aveți permisiunea să faceți modificări pentru acest client.");
        return;
      }
    }
    
    if (
      client?.i4b === "1" &&
      String(user?.role) === "3" &&
      String(client?.assigned_to) !== String(user?.user_id)
    ) {
      alert("⛔ Nu poti adauga serii pentru acest client. Lucrarea nu ti-a fost atribuita.");
      return;
    }
  
    const currentTime = Date.now();
    if (currentTime - lastInvertorAddTime < 2000) { // 2 secunde restricție
      alert("Asteptati 2 secunde inainte de a adauga o noua serie invertor!");
      return;
    }
  
    setIsAddingInvertor(true);
    axios
      .post(
        "https://tj.marenergy.ro/api.php",
        {
          action: "add_invertor_series",
          client_id: id,
          series_invertor: sanitizedSeries,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        setInvertorSeries([{ id: Date.now(), series_invertor: sanitizedSeries }, ...invertorSeries]);
        setNewInvertor("");
        setLastInvertorAddTime(currentTime);

        setInvertorAddedPing(true);
        setTimeout(() => setInvertorAddedPing(false), 1200);
      })
      .catch((err) => {
        alert(err?.response?.data?.message || "Eroare la adaugarea seriei invertor. Exista deja in baza de date sau ati depasit limita de caractere.");
      })
      .finally(() => {
        setIsAddingInvertor(false);
      });
  };

  const handleAddSmartMeterSeries = () => {
    const sanitizedSeries = newSmartMeter.trim();

    if (sanitizedSeries === "") {
      alert("Introduceti o serie valida!");
      return;
    }
    
    if (sanitizedSeries.length > MAX_SERIES_LENGTH) {
      alert(`Seria pentru smart-meter nu poate avea mai mult de ${MAX_SERIES_LENGTH} caractere.`);
      return;
    }

    // 🔒 Verificare firmă: user trebuie să aparțină aceleiași firme ca și clientul
    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

    // Aplica restricție doar dacă clientul este exclusiv i4b
    if (client?.i4b === "1" && client?.i4a !== "1" && client?.i7 !== "1") {
      const firmeUser = firme.filter(firma => String(user?.[firma]) === "1");
      const firmeClient = firme.filter(firma => String(client?.[firma]) === "1");
    
      const firmeComune = firmeUser.filter(firma => firmeClient.includes(firma));
    
      // Permitem doar dacă userul și clientul au fiecare exact o firmă, și este aceeași
      const arePermisiuneFirma =
        firmeUser.length === 1 &&
        firmeClient.length === 1 &&
        firmeComune.length === 1;
    
      if (!arePermisiuneFirma) {
        alert("⛔ Nu aveți permisiunea să faceți modificări pentru acest client.");
        return;
      }
    }

    if (
      client?.i4b === "1" &&
      String(user?.role) === "3" &&
      String(client?.assigned_to) !== String(user?.user_id)
    ) {
      alert("⛔ Nu poti adauga serii pentru acest client. Lucrarea nu ti-a fost atribuita.");
      return;
    }
  
    const currentTime = Date.now();
    if (currentTime - lastSmartMeterAddTime < 2000) {
      alert("Asteptati 2 secunde inainte de a adauga o noua serie Smart Meter!");
      return;
    }
  
    setIsAddingSmartMeter(true); // 👈 start loader
    axios
      .post(
        "https://tj.marenergy.ro/api.php",
        {
          action: "add_smart_meter_series",
          client_id: id,
          series_smart_meter: sanitizedSeries,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        setSmartMeterSeries([{ id: Date.now(), series_smart_meter: sanitizedSeries }, ...smartMeterSeries]);
        setNewSmartMeter("");
        setLastSmartMeterAddTime(currentTime);

        setSmartMeterAddedPing(true);
        setTimeout(() => setSmartMeterAddedPing(false), 1200);
      })
      .catch((err) => {
        alert(err?.response?.data?.message || "Eroare la adaugarea seriei Smart Meter. Exista deja in baza de date sau ati depasit limita de caractere.");
      })
      .finally(() => setIsAddingSmartMeter(false));
  };

  const handleAddDongleSeries = () => {
    const sanitizedSeries = validateSeriesInput(
      newDongle,
      DongleSeries.map((item) => item.series_dongle),
      "dongle"
    );
    
    if (!sanitizedSeries) {
      return;
    }

    // 🔒 Verificare firmă: user trebuie să aparțină aceleiași firme ca și clientul
    const firme = ["constanta", "eolos", "furgon", "panelvolt", "marenergy", "redans", "optim"];

    // Aplica restricție doar dacă clientul este exclusiv i4b
    if (client?.i4b === "1" && client?.i4a !== "1" && client?.i7 !== "1") {
      const firmeUser = firme.filter(firma => String(user?.[firma]) === "1");
      const firmeClient = firme.filter(firma => String(client?.[firma]) === "1");
    
      const firmeComune = firmeUser.filter(firma => firmeClient.includes(firma));
    
      // Permitem doar dacă userul și clientul au fiecare exact o firmă, și este aceeași
      const arePermisiuneFirma =
        firmeUser.length === 1 &&
        firmeClient.length === 1 &&
        firmeComune.length === 1;
    
      if (!arePermisiuneFirma) {
        alert("⛔ Nu aveți permisiunea să faceți modificări pentru acest client.");
        return;
      }
    }

    if (
      client?.i4b === "1" &&
      String(user?.role) === "3" &&
      String(client?.assigned_to) !== String(user?.user_id)
    ) {
      alert("⛔ Nu poti adauga serii pentru acest client. Lucrarea nu ti-a fost atribuita.");
      return;
    }
  
    const currentTime = Date.now();
    if (currentTime - lastDongleAddTime < 2000) {
      alert("Asteptati 2 secunde inainte de a adauga o noua serie Dongle!");
      return;
    }
  
    setIsAddingDongle(true); // 👈 start loader
    axios
      .post(
        "https://tj.marenergy.ro/api.php",
        {
          action: "add_dongle_series",
          client_id: id,
          series_dongle: sanitizedSeries,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        setDongleSeries([{ id: Date.now(), series_dongle: sanitizedSeries }, ...DongleSeries]);
        setNewDongle("");
        setLastDongleAddTime(currentTime);

        setDongleAddedPing(true);
        setTimeout(() => setDongleAddedPing(false), 1200);
      })
      .catch((err) => {
        alert(err?.response?.data?.message || "Eroare la adaugarea seriei Dongle. Exista deja in baza de date sau ati depasit limita de caractere.");
      })
      .finally(() => setIsAddingDongle(false));
  };

  // ——— Save equipment type on selection with confirm ———
  const [savingType, setSavingType] = useState(null); // "tippanou" | "tipinvertor" | "tipacumulator" | null

  const saveEquipmentType = async ({ field, value, friendlyName }) => {
    // field: "tippanou" | "tipinvertor" | "tipacumulator"
    // value: string (ex. "Jinko 490W")
    // friendlyName: ex. "tipul panoului", "tipul invertorului", "tipul acumulatorului"

    if (!value) return; // ignoră selecția goală
    if (field === "tipinvertor" && !OPTIUNI_INVERTOR_VIZIBILE.includes(value)) {
      alert("Optiunea de invertor nu este permisă pentru acest tip de client.");
      return;
    }
    const numeClient = client?.name || "client";

    const msg = `Ești sigur că vrei să selectezi ${friendlyName} „${value}” pentru ${numeClient}?`;
    const ok = window.confirm(msg);
    if (!ok) return;

    try {
      setSavingType(field);
      const res = await axios.post(
        "https://tj.marenergy.ro/api.php",
        {
          action: "save_equipment_type",
          client_id: id,
          field,
          value,
          // user_id: user?.user_id, // dacă vrei să loghezi și userul
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      // Actualizează local clientul ca să se vadă imediat schimbarea
      setClient((prev) => ({
        ...prev,
        [field]: value,
      }));

      alert(res.data?.message || "Tipul a fost salvat.");
    } catch (e) {
      alert(e?.response?.data?.message || "Eroare la salvarea tipului.");
    } finally {
      setSavingType(null);
    }
  };

  useEffect(() => {
    if (client?.tippanou) setTipPanouSelectat(client.tippanou);
    if (client?.tipacumulator) setTipAcumulatorSelectat(client.tipacumulator);
    if (client?.tipinvertor) setTipInvertorSelectat(client.tipinvertor);
  }, [client?.tippanou, client?.tipacumulator, client?.tipinvertor]);  
    
  const handleAddProsumatorLog = () => {
    if (newProsumatorLog.trim() === "") {
      alert("Introduceți un mesaj valid!");
      return;
    }

    if (!user || !user.user_id) {
      console.error("❌ Eroare: user_id lipsă");
      return;
    }

    axios
      .post("https://tj.marenergy.ro/api.php", {
        action: "add_prosumator_log",
        client_id: id,
        message: newProsumatorLog,
        //user_id: user.user_id,
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(() => {
        setProsumatorLogs([{ message: newProsumatorLog, user_name: user.name, created_at: new Date().toISOString() }, ...prosumatorLogs]);
        setNewProsumatorLog("");
      })
      .catch(() => alert("Eroare la adăugarea mesajului"));
  };

  const handleAddGeneralLog = () => {
    if (newGeneralLog.trim() === "") {
      alert("Introduceți un mesaj valid!");
      return;
    }

    if (!user || !user.user_id) {
      console.error("❌ Eroare: user_id lipsă");
      return;
    }

    axios
      .post("https://tj.marenergy.ro/api.php", {
        action: "add_general_log",
        client_id: id,
        message: newGeneralLog,
        //user_id: user.user_id,
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(() => {
        setGeneralLogs([{ message: newGeneralLog, user_name: user.name, created_at: new Date().toISOString() }, ...generalLogs]);
        setNewGeneralLog("");
      })
      .catch(() => alert("Eroare la adăugarea mesajului general"));
  };

  const handleAssign = (clientId, userId) => {
    const selectedUser = availableAssignees.find(a => String(a.user_id) === String(userId));
    const confirmMsg = `Esti sigur ca vrei sa atribui această lucrare lui ${selectedUser?.name || 'utilizatorul selectat'}?`;
  
    if (!window.confirm(confirmMsg)) return;
  
    axios.post("https://tj.marenergy.ro/api.php", {
      action: "assign_client",
      client_id: clientId,
      user_id: userId
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
    .then((res) => {
      alert("Lucrarea a fost atribuită cu succes");
      window.location.reload();
      setClient((prev) => ({
        ...prev,
        assigned_to: userId,
      }));
    })
    .catch((err) => {
      alert(err.response?.data?.error || "Eroare la atribuirea lucrarii");
    });    
  }; 

  const isSimDirty = useMemo(() => {
    if (!lastSavedSim) return false;
  
    const currentSimInstalled = simInstalled;
    const currentSimOperator =
      simInstalled === "da" ? (simOperator || "") : "";
    const currentSimIdentifier =
      simInstalled === "da" ? (simIdentifier || "") : "";
  
    return (
      currentSimInstalled !== lastSavedSim.simInstalled ||
      currentSimOperator !== (lastSavedSim.simOperator || "") ||
      currentSimIdentifier !== (lastSavedSim.simIdentifier || "")
    );
  }, [simInstalled, simOperator, simIdentifier, lastSavedSim]);  
  
  const isSimConfirmed = useMemo(() => {
    if (!lastSavedSim) return false;
  
    if (lastSavedSim.simInstalled === "nu") return true;
  
    if (lastSavedSim.simInstalled === "da") {
      return !!(lastSavedSim.simIdentifier && lastSavedSim.simIdentifier.trim());
    }
  
    return false;
  }, [lastSavedSim]);
  
  const isSimSaveValid = useMemo(() => {
    if (simInstalled !== "da" && simInstalled !== "nu") return false;
    if (simInstalled === "nu") return true;
  
    if (!simOperator) return false;
    if (!simIdentifier || !simIdentifier.trim()) return false;
    if (simIdentifier.length > 30) return false;
  
    return true;
  }, [simInstalled, simOperator, simIdentifier]);

  const handleSaveSimData = async () => {
    if (!isSimSaveValid) {
      alert("Completeaza corect datele cartelei inainte de salvare.");
      return;
    }
  
    try {
      setIsSavingSim(true);
      setSimSaveMessage("");
  
      const payload = {
        action: "save_sim_data",
        client_id: id,
        sim_installed: simInstalled === "da" ? 1 : 0,
        sim_operator: simInstalled === "da" ? simOperator : null,
        sim_identifier: simInstalled === "da" ? simIdentifier : null,
      };
  
      const res = await axios.post("https://tj.marenergy.ro/api.php", payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
  
      // ✅ acum devine "confirmat" și se blochează automat
      setLastSavedSim({
        simInstalled,
        simOperator: simInstalled === "da" ? (simOperator || "") : "",
        simIdentifier: simInstalled === "da" ? (simIdentifier || "") : "",
      });      
  
      setSimSaveMessage(res?.data?.message || "Datele cartelei au fost salvate ✓");
      setTimeout(() => setSimSaveMessage(""), 2500);
    } catch (e) {
      alert("Eroare la salvarea datelor cartelei.");
    } finally {
      setIsSavingSim(false);
    }
  };

  const maintenanceCaseCount = Number(
    client?.mentenanta_active_case_count || 0
  );
  
  const hasActiveMaintenanceCase =
    String(client?.cu_probleme) === "1" ||
    maintenanceCaseCount > 0;
  
  const maintenanceCaseUrl =
    client?.maintenance_active_case?.central_url || "";

  useEffect(() => {
    if (simInstalled === "nu") {
      setSimOperator("");
      setSimIdentifier("");
    }
  }, [simInstalled]);  

  const handleGenerateLocation = () => {
    const confirmGenerate = window.confirm("Esti sigur ca vrei sa generezi locatia Google Maps pentru acest client?");
    if (!confirmGenerate) return;
  
    if (!navigator.geolocation) {
      alert("Browserul nu suportă geolocalizare.");
      return;
    }
  
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const link = `https://www.google.com/maps?q=${latitude},${longitude}`;
  
        axios.post("https://tj.marenergy.ro/api.php", {
          action: "update_google_maps",
          client_id: id,
          maps_link: link,
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        })
          .then(() => {
            alert("Link Google Maps generat cu succes!");
            setClient((prev) => ({ ...prev, google_maps_link: link }));
          })
          .catch(() => {
            alert("Eroare la salvarea linkului.");
          });
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            alert("Permisiunea pentru locație a fost refuzată.");
            break;
          case error.POSITION_UNAVAILABLE:
            alert("Informația de locație nu este disponibilă.");
            break;
          case error.TIMEOUT:
            alert("Timeout la obținerea locației. Încearcă din nou.");
            break;
          default:
            alert("Eroare necunoscută la obținerea locației.");
            break;
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };  


  return (
    <div className="container mt-2">
      <div className="user-info">
        <div className="user-badges">
          <Link
            to={`/user/${user?.user_id || user?.id}`}
            className="up-user-name"
          >
            👤 {user?.name || "Utilizator"}
          </Link>
          {user?.i4b === "1" && getFirmaUserului(user) && (
            <span className="firma-user">🏢 {getFirmaUserului(user)}</span>
          )}
        </div>
      </div>
      {error && (
        <div className="alert alert-danger mt-3" role="alert">
          {error}
        </div>
      )}
      <div className="logo-container">
        <Link to="/dashboard">
          <img src="/images/Logo.webp" alt="Logo" className="clientprofile-logo" />
        </Link>
      </div>
      <hr />

      <h1 className="text-center">Profilul Clientului</h1>
      <hr />
    
      <h3 className="text-center">{client?.name}</h3>
      <h4 className="text-center">
        {client?.i4a === "1" ? (
          <span className="badge bg-info text-dark">i4a</span>
        ) : client?.i4b === "1" ? (
          <span className="badge bg-warning text-dark">i4b</span>
        ) : client?.i7 === "1" ? (
          <span className="badge bg-warning text-dark">i7</span>
        ) : null}
      </h4>

      {hasActiveMaintenanceCase && (
        <div
          className="alert d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mt-4"
          role="alert"
          style={{
            background:
              "linear-gradient(135deg, #fff1f1 0%, #ffffff 100%)",
            border: "1px solid #dc3545",
            borderLeft: "6px solid #dc3545",
            borderRadius: "14px",
            boxShadow: "0 8px 24px rgba(220, 53, 69, 0.12)",
          }}
        >
          <div>
            <div className="fw-bold text-danger fs-5">
              ⚠️ Caz de mentenanță activ
            </div>

            <div className="text-dark mt-1">
              Acest beneficiar are {maintenanceCaseCount || 1}{" "}
              {(maintenanceCaseCount || 1) === 1
                ? "caz activ"
                : "cazuri active"}

              {client?.maintenance_active_case?.case_number
                ? ` · ${client.maintenance_active_case.case_number}`
                : ""}
            </div>
          </div>

          {maintenanceCaseUrl && (
            <a
              href={maintenanceCaseUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-danger fw-bold px-4"
              style={{
                whiteSpace: "nowrap",
                borderRadius: "10px",
              }}
            >
              Deschide cazul ↗
            </a>
          )}
        </div>
      )}

      {/* === FACTURAT INC-PANEL (vizibil DOAR pentru role=1) === */}
      {String(user?.role) === "1" && (
        <div className="text-center mt-2">
          {String(client?.facturat_vulnerabili) === "1" ? (
            // ✅ când e 1 → doar text verde
            <span className="text-success fw-bold">FACTURAT INC-PANEL</span>
          ) : (
            // ✅ când e 0 → afișează checkbox-ul
            <div className="form-check d-inline-flex align-items-center gap-2">
              <input
                type="checkbox"
                className="form-check-input"
                id="facturatIncPanel"
                defaultChecked={false}
                onChange={async () => {
                  const confirmUpdate = window.confirm(
                    "Ești sigur că vrei să marchezi acest client ca FACTURAT INC-PANEL?"
                  );
                  if (!confirmUpdate) return; // ❌ anulează dacă userul apasă Cancel

                  try {
                    await axios.post(
                      "https://tj.marenergy.ro/api.php",
                      {
                        action: "update_facturat_vulnerabili",
                        client_id: client.id,
                        value: 1,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                      }
                    );

                    // ✅ actualizează local clientul → dispare checkbox-ul și apare textul verde
                    setClient((prev) => ({ ...prev, facturat_vulnerabili: "1" }));
                  } catch (err) {
                    alert("Nu s-a putut actualiza 'Facturat INC-PANEL'.");
                  }
                }}
              />
              <label htmlFor="facturatIncPanel" className="form-check-label">
                Facturat INC-PANEL
              </label>
            </div>
          )}
        </div>
      )}

      {/*{canAssignI4a && !client.assigned_to && (
        <div className="atribuire-lucrare-container">
          <label className="form-label">🔧 Atribuie aceasta lucrare:</label>
          <select
            className="form-select atribuire-select"
            value={client.assigned_to ?? ""}
            onChange={(e) => handleAssign(client.id, e.target.value)}
          >
            <option value="">
              {availableAssignees.length > 0
                ? "Selectează un sef de echipa"
                : "Niciun utilizator disponibil"}
            </option>
            {availableAssignees.map((assignee) => (
              <option key={assignee.user_id} value={assignee.user_id}>
                {assignee.name}
              </option>
            ))}
          </select>
        </div>
      )}*/}

      {canAssign && !client.assigned_to && areOConjunctieDeFirma && (
        <div className="atribuire-lucrare-container">
          <label className="form-label">🔧 Atribuie aceasta lucrare:</label>
          <select
            className="form-select atribuire-select"
            value={client.assigned_to ?? ""}
            onChange={(e) => handleAssign(client.id, e.target.value)}
          >
            <option value="">
              {availableAssignees.length > 0
                ? "Selectează un sef de echipa"
                : "Niciun utilizator disponibil"}
            </option>
            {availableAssignees.map((assignee) => (
              <option key={assignee.user_id} value={assignee.user_id}>
                {assignee.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <br />

      {/* 🔹 Meniu pentru tab-uri */}
      <div className="tabs-container">
        <button
          type="button"
          className={`tab-button ${
            activeTab === "vizita_teren" ? "active" : ""
          }`}
          onClick={() => setActiveTab("vizita_teren")}
        >
          Vizita de Teren
        </button>

        {client?.i4b === "1" && (
          <button
            className={`tab-button ${activeTab === "informatii" ? "active" : ""}`}
            onClick={() => setActiveTab("informatii")}
          >
            Informatii
          </button>
        )}

        {String(client?.status) !== "6" && (() => {
          const firme = [
            "constanta",
            "eolos",
            "furgon",
            "panelvolt",
            "marenergy",
            "redans",
            "optim",
          ];

          const isI4b = String(client?.i4b) === "1";

          const hasCommonFirma =
            !isI4b ||
            firme.some(
              (firma) =>
                String(user?.[firma]) === "1" &&
                String(client?.[firma]) === "1"
            );

          if (!hasCommonFirma) return null;

          return (
            <span
              className="status-doc-serii-disabled-wrapper"
              title="Aceasta sectiune este momentan in lucru"
            >
              <button
                type="button"
                className="tab-button status-doc-serii-disabled"
                disabled
                aria-disabled="true"
              >
                <span
                  className="status-doc-serii-x"
                  aria-hidden="true"
                >
                  X
                </span>

                Status/Doc/Serii

                <span className="status-doc-serii-label">
                  In lucru
                </span>
              </button>
            </span>
          );
        })()}
      </div>

      <div className="card p-4 shadow mt-4">

      {activeTab === "vizita_teren" && (
          <div className="visit-form">
            <p>
              <strong>Montaj realizat de:</strong>{" "}
              {client?.assigned_to && client?.assigned_to_name ? (
                <Link
                  to={`/user/${client.assigned_to}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit"
                  }}
                >
                  {client.assigned_to_name}
                </Link>
              ) : (
                "Nefinalizat"
              )}
            </p>
            <p>
              <strong>Telefon:</strong>{" "}
              {client?.phone && client?.secondaryPhone
                ? `${client.phone} / ${client.secondaryPhone}`
                : client?.phone || client?.secondaryPhone || "Nu este disponibil"}
            </p>
            <p><strong>Adresa:</strong> {client?.address || "Nu este disponibilă"}</p>
            
            {!canEditSim && (
              <p>
                <strong>Cartela:</strong>{" "}
                {simInstalled === "da"
                  ? `Da${simOperator ? " / " + simOperator : ""}${simIdentifier ? " / " + simIdentifier : ""}`
                  : simInstalled === "nu"
                  ? "Nu"
                  : "Nesetat"}
              </p>
            )}

            {client?.google_maps_link ? (
              <p>
                <strong>Locatie Google Maps:</strong>{" "}
                <a
                  href={client.google_maps_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007bff", textDecoration: "underline" }}
                >
                  Vezi locatia
                </a>
              </p>
            ) : (
              !isVisitComplete && (
                <button
                  className="btn btn-outline-success mt-2"
                  onClick={handleGenerateLocation}
                >
                  📍 Genereaza locatie Google Maps
                </button>
              )
            )}

            <hr />

            <label className="fw-bold">Tip Acoperis:</label>

            <select
              className="form-control"
              value={client?.acoperis_selectie || ""}
              onChange={(e) => {
                const selectie = e.target.value;

                setClient({
                  ...client,
                  acoperis_selectie: selectie,
                  acoperis: selectie === "alt_tip" ? "" : selectie,
                });
              }}
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>

              <option value="Tabla">Tabla</option>
              <option value="Tigla">Tigla</option>
              <option value="alt_tip">Alt tip:</option>
            </select>

            {client?.acoperis_selectie === "alt_tip" && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Scrie tipul acoperisului..."
                maxLength={255}
                value={client?.acoperis || ""}
                onChange={(e) =>
                  setClient({
                    ...client,
                    acoperis: e.target.value,
                  })
                }
                disabled={isVisitComplete && !isEditing}
              />
            )}

            <label className="fw-bold">Numar ape acoperis:</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control"
              placeholder="Exemplu: 2"
              value={client?.numar_ape_acoperis ?? ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  numar_ape_acoperis: e.target.value.replace(/\D/g, ""),
                })
              }
              disabled={isVisitComplete && !isEditing}
            />

            <label className="fw-bold">Expunere acoperis:</label>
            <select
              className="form-control"
              value={client?.expunere_acoperis || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  expunere_acoperis: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>
              <option value="Sud">Sud</option>
              <option value="Est/Vest">Est/Vest</option>
            </select>

            <label className="fw-bold">
              Unde se poate monta sistemul fotovoltaic?
            </label>
            <select
              className="form-control"
              value={client?.locatie_montaj_sistem_fotovoltaic || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  locatie_montaj_sistem_fotovoltaic: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>
              <option value="Pe acoperis">Pe acoperis</option>
              <option value="La sol">La sol</option>
              <option value="Ambele">Ambele</option>
            </select>

            <label className="fw-bold">Bransament:</label>
            <select 
              className="form-control" 
              value={client?.bransament || ""} 
              onChange={(e) => setClient({...client, bransament: e.target.value})} 
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>Selecteaza o optiune...</option>
              <option value="monofazat">Monofazat</option>
              <option value="trifazat">Trifazat</option>
            </select>

            <label className="fw-bold">Locatia contorului:</label>
            <select
              className="form-control"
              value={client?.locatie_contor || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  locatie_contor: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>
              <option value="Pe stalp exterior">Pe stalp exterior</option>
              <option value="Pe gard">Pe gard</option>
              <option value="Pe casa">Pe casa</option>
            </select>

            <label className="fw-bold">
              Trebuie schimbata firida exterioara?
            </label>
            <select
              className="form-control"
              value={client?.firida_exterioara_trebuie_schimbata || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  firida_exterioara_trebuie_schimbata: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selectează o opțiune...
              </option>
              <option value="DA">Da</option>
              <option value="NU">Nu</option>
            </select>

            <label className="fw-bold">Tip Tablou:</label>
            <select 
              className="form-control" 
              value={client?.tiptablou || ""} 
              onChange={(e) => setClient({...client, tiptablou: e.target.value})} 
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>Selectează o opțiune...</option>
              <option value="busoane">Busoane</option>
              <option value="sigurante">Sigurante</option>
            </select>

            <label className="fw-bold">
              Tabloul existent trebuie schimbat?
            </label>
            <select
              className="form-control"
              value={client?.tablou_trebuie_schimbat || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  tablou_trebuie_schimbat: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>
              <option value="DA">Da</option>
              <option value="NU">Nu</option>
            </select>

            <label className="fw-bold">Impamantare:</label>
            <select 
              className="form-control" 
              value={client?.impamantare || ""} 
              onChange={(e) => setClient({...client, impamantare: e.target.value})} 
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>Selectează o opțiune...</option>
              <option value="DA">DA</option>
              <option value="NU">NU</option>
            </select>

            <label className="fw-bold">Beneficiarul are internet?</label>
            <select 
              className="form-control" 
              value={client?.internet || ""} 
              onChange={(e) => setClient({...client, internet: e.target.value})} 
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>Selectează o opțiune...</option>
              <option value="DA">DA</option>
              <option value="NU">NU</option>
            </select> 

            <label className="fw-bold">Numar de telefon suplimentar:</label>
            <input 
              type="text" 
              className="form-control" 
              value={client?.secondaryPhone || ""} 
              onChange={(e) => setClient(client ? {...client, secondaryPhone: e.target.value} : {})} 
              disabled={isVisitComplete && !isEditing} />


            <label className="fw-bold">E-mail client:</label>
            <input
              type="email"
              className="form-control"
              placeholder="exemplu@email.ro"
              maxLength={100}
              required
              value={client?.email || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  email: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            />

            {(String(user?.role) === "1" || String(user?.role) === "2") && (
              <>
                <label className="fw-bold">
                  Contractul cu furnizorul de energie este pe numele beneficiarului?
                </label>
                <select
                  className="form-control"
                  value={client?.ctrenergie || ""}
                  onChange={(e) => setClient({ ...client, ctrenergie: e.target.value })}
                  disabled={isVisitComplete && !isEditing}
                >
                  <option value="" disabled>
                    Selectează o opțiune...
                  </option>
                  <option value="DA">DA</option>
                  <option value="NU">NU</option>
                  <option value="DANU">DA, DAR ESTE PIERDUT</option>
                </select>
              </>
            )}

            <label className="fw-bold">
              Suprafata cladire construita (m2):
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control"
              placeholder="Exemplu: 120"
              value={client?.suprafata_cladire_construita ?? ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  suprafata_cladire_construita:
                    e.target.value.replace(/\D/g, ""),
                })
              }
              disabled={isVisitComplete && !isEditing}
            />

            <label className="fw-bold">
              Anul constructiei cladirii:
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              className="form-control"
              placeholder="Exemplu: 1995"
              value={client?.an_constructie_cladire ?? ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  an_constructie_cladire:
                    e.target.value.replace(/\D/g, "").slice(0, 4),
                })
              }
              disabled={isVisitComplete && !isEditing}
            />

            <label className="fw-bold">
              Material pereti casa:
            </label>
            <input
              type="text"
              className="form-control"
              maxLength={255}
              placeholder="Exemplu: Caramida, BCA, chirpici..."
              value={client?.material_pereti_casa || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  material_pereti_casa: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            />

            <label className="fw-bold">
              Grosime pereti (cm):
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control"
              placeholder="Exemplu: 30"
              value={client?.grosime_pereti_cm ?? ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  grosime_pereti_cm:
                    e.target.value.replace(/\D/g, ""),
                })
              }
              disabled={isVisitComplete && !isEditing}
            />

            <label className="fw-bold">
              Izolatie pod:
            </label>
            <select
              className="form-control"
              value={client?.izolatie_pod || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  izolatie_pod: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>
              <option value="DA">Da</option>
              <option value="NU">Nu</option>
            </select>

            <label className="fw-bold">
              Izolatie pereti:
            </label>
            <select
              className="form-control"
              value={client?.izolatie_pereti || ""}
              onChange={(e) =>
                setClient({
                  ...client,
                  izolatie_pereti: e.target.value,
                })
              }
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>
              <option value="DA">Da</option>
              <option value="NU">Nu</option>
            </select>

            <label className="fw-bold">
              Sursa incalzire:
            </label>
            <select
              className="form-control"
              value={client?.sursa_incalzire || ""}
              onChange={(e) => {
                const valoare = e.target.value;

                setClient({
                  ...client,
                  sursa_incalzire: valoare,
                  sursa_incalzire_altele:
                    valoare === "Alte metode de incalzire"
                      ? client?.sursa_incalzire_altele || ""
                      : "",
                });
              }}
              disabled={isVisitComplete && !isEditing}
            >
              <option value="" disabled>
                Selecteaza o optiune...
              </option>

              <option value="Centrala Termica pe Gaz">
                Centrala termica pe gaz
              </option>

              <option value="Centrala Termica pe Lemne">
                Centrala termica pe lemne
              </option>

              <option value="Centrala Termica pe Peleti">
                Centrala termica pe peleti
              </option>

              <option value="Soba">
                Soba
              </option>

              <option value="Alte metode de incalzire">
                Alte metode de incalzire
              </option>
            </select>
            {client?.sursa_incalzire ===
              "Alte metode de incalzire" && (
              <>
                <label className="fw-bold">
                  Specificati metoda de incalzire:
                </label>

                <input
                  type="text"
                  className="form-control"
                  maxLength={255}
                  placeholder="Introduceti metoda de incalzire..."
                  value={client?.sursa_incalzire_altele || ""}
                  onChange={(e) =>
                    setClient({
                      ...client,
                      sursa_incalzire_altele: e.target.value,
                    })
                  }
                  disabled={isVisitComplete && !isEditing}
                />
              </>
            )}

            <label className="fw-bold">Mentiuni suplimentare beneficiar:</label>
            <textarea 
              className="form-control" 
              rows="3" 
              value={client?.notes || ""} 
              onChange={(e) => setClient(client ? {...client, notes: e.target.value} : {})} 
              disabled={isVisitComplete && !isEditing}></textarea>

            <hr />

            {/* Secțiunea pentru Contract Energie — vizibilă doar pentru user.role 1 și 2 */}
            {(String(user?.role) === "1" || String(user?.role) === "2") && (
              <>
                {/* Upload contract energie */}
                {client?.ctrenergie === "DA" && (!isVisitComplete || isEditing) && (
                  <div className="mt-4">
                    <h5>📄 Contract Energie</h5>
                    <p className="small-message">Incarcati contractul in format PDF</p>
                    <input
                      type="file"
                      onChange={handleContractFileChange}
                      className="form-control"
                      ref={contractFileInputRef}
                    />
                    <button 
                      className="btn btn-primary mt-2" 
                      onClick={handleUploadContract} 
                      disabled={isContractUploading}
                    >
                      {isContractUploading ? "Se încarca..." : "Incarca Contract"}
                    </button>
                  </div>
                )}

                {/* Lista contracte încărcate */}
                {contractDocuments.length > 0 && (
                  <>
                    <h5 className="mt-4">📂 Contracte Energie Încărcate</h5>
                    <ul className="list-group uploaded-documents">
                      {contractDocuments.map((doc) => (
                        <li
                          key={doc.id}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <a
                            href={`https://tj.marenergy.ro${doc.file_path}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={doc.file_name}
                            className="file-link"
                          >
                            {doc.file_name.length > 20
                              ? doc.file_name.substring(0, 20) + "..."
                              : doc.file_name}
                          </a>
                          <span className="uploaded-by">
                            De: <strong>{doc.uploaded_by || "Necunoscut"}</strong>
                          </span>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </>
            )}

            {/* Upload Poze Beneficiar — vizibil doar pentru user.role 1 și 2 */}
            <>
              {(!isVisitComplete || isEditing) && (
                <div className="mt-4">
                  <h5>📸 Poze Vizita Teren</h5>

                  <label>Tipul de poza:</label>
                  <select
                    className="form-control mb-2"
                    value={selectedDocumentType}
                    onChange={(e) => setSelectedDocumentType(e.target.value)}
                  >
                    <option value="poza_acoperis">
                      Poza Acoperis
                    </option>

                    <option value="poze_case_exterior">
                      Poze Case Exterior 
                    </option>

                    <option value="poza_geamuri">
                      Poza Geamuri
                    </option>

                    <option value="poza_grosime_perete">
                      Poza Grosime Perete
                    </option>

                    <option value="poza_tablou">
                      Poza Tablou Electric
                    </option>

                    <option value="poza_factura">
                      Poza Factura Energie
                    </option>

                    <option value="poza_extras_carte_funciara">
                      Poza Extras Carte Funciara
                    </option>

                    <option value="poze_plan_amplasament">
                      Plan Amplasament
                    </option>
                  </select>

                  {/* Progresul fotografiilor încărcate */}
                  <div className="mb-3">
                    {Object.entries(MIN_POZE_VIZITA).map(
                      ([type, minimum]) => {
                        const uploaded = visitPhotoCounts[type] || 0;
                        const complete = uploaded >= minimum;

                        return (
                          <div
                            key={type}
                            className={
                              complete ? "text-success" : "text-danger"
                            }
                          >
                            {formatLabel(type)}: {uploaded}/{minimum}
                          </div>
                        );
                      }
                    )}
                    <div
                      className={
                        numarPozePlanAmplasament >= MIN_POZE_PLAN_AMPLASAMENT
                          ? "text-success"
                          : "text-secondary"
                      }
                    >
                      Poze Plan Amplasament (opțional):{" "}
                      {numarPozePlanAmplasament}/{MIN_POZE_PLAN_AMPLASAMENT}
                    </div>
                  </div>

                  <input
                    type="file"
                    accept={
                      selectedDocumentType === "poze_plan_amplasament"
                        ? ".pdf,.jpg,.jpeg,.png"
                        : ".jpg,.jpeg,.png"
                    }
                    onChange={handleFileChange}
                    className="form-control"
                    ref={fileInputRef}
                  />
                  <button
                    className="btn btn-primary mt-2"
                    onClick={handleUpload}
                    disabled={isUploading}
                  >
                    {isUploading ? "Se încarcă..." : "Încarcă poză"}
                  </button>
                </div>
              )}
            </>

            {visitDocuments.length > 0 ? (
              <>
                <ul className="list-group uploaded-documents">
                  {currentVisitDocs.map((doc) => (
                    <li
                      key={doc.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <a
                        href={`https://tj.marenergy.ro${doc.file_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={doc.file_name}
                        className={`file-link ${
                          visitedDocIds.has(String(doc.id))
                            ? "viewed"
                            : ""
                        }`}
                        onClick={() => markDocVisited(doc.id)}
                        onAuxClick={() => markDocVisited(doc.id)}
                      >
                        {formatLabel(doc.document_type)}
                      </a>

                      <span className="uploaded-by">
                        De:{" "}
                        <strong>
                          {doc.uploaded_by || "Necunoscut"}
                        </strong>
                      </span>
                    </li>
                  ))}
                </ul>

                {visitDocTotalPages > 1 && (
                  <nav
                    className="mt-3"
                    aria-label="Paginare documente vizită"
                  >
                    <ul className="pagination justify-content-center">
                      <li
                        className={`page-item ${
                          visitDocPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          type="button"
                          className="page-link"
                          disabled={visitDocPage === 1}
                          onClick={() =>
                            setVisitDocPage((previousPage) =>
                              Math.max(1, previousPage - 1)
                            )
                          }
                        >
                          Înapoi
                        </button>
                      </li>

                      {Array.from(
                        { length: visitDocTotalPages },
                        (_, index) => {
                          const pageNumber = index + 1;

                          return (
                            <li
                              key={pageNumber}
                              className={`page-item ${
                                visitDocPage === pageNumber
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <button
                                type="button"
                                className="page-link"
                                onClick={() =>
                                  setVisitDocPage(pageNumber)
                                }
                              >
                                {pageNumber}
                              </button>
                            </li>
                          );
                        }
                      )}

                      <li
                        className={`page-item ${
                          visitDocPage === visitDocTotalPages
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          type="button"
                          className="page-link"
                          disabled={
                            visitDocPage === visitDocTotalPages
                          }
                          onClick={() =>
                            setVisitDocPage((previousPage) =>
                              Math.min(
                                visitDocTotalPages,
                                previousPage + 1
                              )
                            )
                          }
                        >
                          Înainte
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </>
            ) : (
              <p className="text-muted">
                Nicio poza incarcata
              </p>
            )}

            {(!isVisitComplete || isEditing) && (
              <button 
                className="btn btn-success mt-3" 
                onClick={handleSaveVisitData} 
                disabled={!isFormValid}
              >
                Salveaza
              </button>
            )}

            {!isVisitComplete && (
              <>
                <p className="text-muted">
                  Butonul 'SALVEAZA' devine disponibil dupa ce s-au completat toate informatiile si dupa ce s-au incarcat toate tipurile de poze.
                </p>
                <p className="text-danger mt-2">
                  <strong>⚠️ Atentie! Dupa salvarea informatiilor, nu le mai puteti edita.</strong>
                </p>
              </>
            )}

          </div>
        )}

        {activeTab === "informatii" && (
          <>
            <p>
              <strong>Firma / Echipa:</strong>{" "}
              {
                // Numele firmei
                client?.constanta === "1" ? "FOTONIA" :
                client?.eolos === "1" ? "EOLOS" :
                client?.furgon === "1" ? "FURGON SERV" :
                client?.panelvolt === "1" ? "PANEL VOLT SOLAR" :
                client?.marenergy === "1" ? "MAR ENERGY" :
                client?.redans === "1" ? "REDANS" :
                client?.optim === "1" ? "OPTIM" :
                "Nespecificata"
              }
              {" / "}
              {
                // Numele persoanei careia i-a fost atribuită (dacă este)
                client?.assigned_to_name
                  ? client.assigned_to_name
                  : "Echipa neatribuita"
              }
            </p>
            <p><strong>Adresa:</strong> {client?.address || "Nu este disponibilă"}</p>
            <p>
              <strong>Telefon:</strong>{" "}
              {client?.phone && client?.secondaryPhone
                ? `${client.phone} / ${client.secondaryPhone}`
                : client?.phone || client?.secondaryPhone || "Nu este disponibil"}
            </p>
            <p><strong>E-mail:</strong> {client?.email || "Nu este disponibil"}</p>
            {client?.notes && (
              <p>
                <strong>Note suplimentare client:</strong>{" "}
                <span style={{ color: "red", fontWeight: "bold" }}>{client.notes}</span>
              </p>
            )}

            {client?.tippanou && (
              <p>
                <strong>Tip Panou Instalat:</strong>{" "}
                <span style={{ color: "red" }}>{client.tippanou}</span>
              </p>
            )}

            {client?.tipinvertor && (
              <p>
                <strong>Tip Invertor Instalat:</strong>{" "}
                <span style={{ color: "red" }}>{client.tipinvertor}</span>
              </p>
            )}

            {client?.tipacumulator && (
              <p>
                <strong>Tip Acumulator Instalat:</strong>{" "}
                <span style={{ color: "red" }}>{client.tipacumulator}</span>
              </p>
            )}

            <hr className="mb-4" />

            <p><strong>Bransament:</strong> {client?.bransament || "Nu este disponibil"}</p>
            <p><strong>Invertor actual client:</strong> {client?.invertor || "Nu este disponibil"}</p>
            <p><strong>Tip acumulator de instalat:</strong> {client?.acumulator || "Nu este disponibil"}</p>

            {(user?.role === "1" || user?.role === "2") && (
              <>
                <hr className="mb-3" />
                <p><strong>CNP Beneficiar:</strong> {client?.cnpbeneficiar || "Nu este disponibil"}</p>
              </>
            )}
          </>
        )}

        {activeTab === "documente" && (
          <>
            <div className="mt-2">
            <label><strong>Status Client:</strong></label>
              <select
                className="form-control"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                {Object.entries(statusLabels)
                  .filter(([key]) => {
                    // 🔒 Ascunde statusul 6 dacă clientul nu e i4a
                    if (key === "6" && client?.i4a !== "1" && client?.i7 !== "1") return false;

                    // 🔒 Statusuri restricționate la rol 1 și 2
                    if ((key === "5" || key === "7") && !(String(user?.role) === "1" || String(user?.role) === "2")) return false;

                    return true;
                  })
                  .map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))}
              </select>

              {(() => {
                const selected = String(selectedStatus);
                const current = String(client?.status);

                const selectedNeedsReason = ["1", "8"].includes(selected);
                const alreadyInReasonStatus = ["1", "8"].includes(current);
                const statusUnchanged = selected === current;

                // ✅ Dacă deja este în status 1/8 și nu schimbi statusul -> afișează motivul (read-only)
                if (alreadyInReasonStatus && statusUnchanged) {
                  return (
                    <div className="form-group mt-2">
                      <label><strong>Motiv:</strong></label>
                      <div className="form-control" style={{ height: "auto", whiteSpace: "pre-wrap" }}>
                        {statusReason?.trim() ? statusReason : "(fără motiv înregistrat)"}
                      </div>
                    </div>
                  );
                }

                // ✅ Dacă SCHIMBI către 1/8 -> arată textarea ca să scrii motivul
                if (selectedNeedsReason && !statusUnchanged) {
                  return (
                    <div className="form-group mt-2">
                      <label><strong>Motiv (obligatoriu):</strong></label>
                      <textarea
                        className="form-control"
                        rows={2}
                        value={statusReason}
                        onChange={(e) => setStatusReason(e.target.value)}
                        placeholder="Scrie motivul..."
                      />
                    </div>
                  );
                }

                return null;
              })()}

              <div>
                <button
                  className="btn btn-warning mt-2"
                  onClick={handleChangeStatus}
                  disabled={isChangingStatus}
                >
                  {isChangingStatus ? "Se incarca... (30 sec)" : "Schimba Status"}
                </button>

                {getMissingDocuments().length > 0 && (
                  <div style={{ position: "relative", display: "inline-block", marginLeft: "10px" }}>
                    <span
                      className="missing-doc-icon"
                      onClick={() => {
                        if (isMobile) {
                          setShowTooltip(prev => !prev);
                        }
                      }}
                      onMouseEnter={() => {
                        if (!isMobile) setShowTooltip(true);
                      }}
                      onMouseLeave={() => {
                        if (!isMobile) setShowTooltip(false);
                      }}
                    >
                      ❗
                    </span>

                    {showTooltip && (
                      <div className="doc-tooltip">
                        <strong>Lipsesc:</strong>
                        <ul style={{ paddingLeft: "20px", marginBottom: 0 }}>
                          {getMissingDocuments().map((doc, idx) => (
                            <li key={idx}>{doc}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {(lastStatusUpdate !== "Nicio actualizare" && lastUpdatedBy !== "Necunoscut") && (
                <p className="text-muted mt-2">
                  <small>Ultima actualizare: {lastStatusUpdate} de catre {lastUpdatedBy}</small>
                </p>
              )}
            </div>

            <hr />
            
            <div className="mt-3">
              <h4>📤 Incarca documente</h4>

              <select 
                className="form-control mb-2" 
                value={selectedDocumentType} 
                onChange={(e) => setSelectedDocumentType(e.target.value)}
              >

                {/* Documente Executie 
                {(
                  String(user?.role) === "1" ||
                  String(user?.role) === "2" ||
                  (String(user?.role) === "3" && ["1", "2"].includes(client?.status))
                ) && (*/}
                <optgroup label="🛠️ Documente Executie">
                  {tabCategories.executie
                    .filter((type) => {
                      // Ascunde cele 2 tipuri dacă clientul nu este i4a
                      if (
                        ["poza_acoperis_dupa", "poza_casa_dupa"].includes(type) &&
                        client?.i4a !== "1" &&
                        client?.i7 !== "1"
                      ) {
                        return false;
                      }
                      return true;
                    })
                    .map((type) => (
                      <option key={type} value={type}>
                        {formatLabel(type)}
                      </option>
                    ))}
                </optgroup>

                {(() => {
                  const status = String(client?.status);
                  const isRole12 = String(user?.role) === "1" || String(user?.role) === "2";
                  const isI4a = String(client?.i4a) === "1";
                  const isI7  = String(client?.i7) === "1";
                  const isI4b = String(client?.i4b) === "1";

                  const SHOW_3PLUS = ["3", "4", "5", "7"]; // statusuri 3 încolo
                  const visibleAltele = tabCategories.altele.filter((type) => {
                    const isPV_FV = type === "proces_verbal_fotovoltaice";
                    const isPV_ST = type === "proces_verbal_stocare";
                    const isPV_I4B = type === "proces_verbal";

                    // ✅ Rol 1/2: arată mereu 'contract_energie_actualizat', indiferent de status
                    if (type === "contract_energie_actualizat" && isRole12) {
                      return true;
                    }

                    // 1) Status 2: 
                    //   - i4a: FV + ST
                    //   - i7 : doar FV
                    if (status === "2") {
                      if (isI4a && (isPV_FV || isPV_ST)) return true;
                      if (isI7  &&  isPV_FV)              return true;
                      return false;
                    }

                    // 2) De la 3 încolo:
                    if (SHOW_3PLUS.includes(status)) {
                      // i4a: FV + ST
                      if (isI4a && (isPV_FV || isPV_ST)) return true;
                      // i7: doar FV
                      if (isI7 && isPV_FV) return true;

                      // i4b: proces_verbal la 3,4,5,7
                      if (isPV_I4B) return isI4b;

                      // doar role 1/2 văd restul "altele"
                      if (!isRole12) return false;

                      // certificat_racordare doar la 4,5,7
                      if (type === "certificat_racordare") return ["4", "5", "7"].includes(status);

                      // --- DOVEZI PROSUMATOR în funcție de program ---
                      if (
                        type === "dovada_prosumator" ||
                        type === "dovada_prosumator_1" ||
                        type === "dovada_prosumator_2"
                      ) {
                        // ascunde toate dovezile la status 4 și 7
                        if (["4", "7"].includes(status)) return false;

                        if (type === "dovada_prosumator") {
                          // vizibilă pentru i4a și i4b
                          return isI4a || isI4b;
                        }

                        // dovada_prosumator_1 / _2 doar pentru i7
                        return isI7;
                      }

                      // restul documentelor la 3,4,5,7
                      return true;
                    }

                    // 3) Orice alt status (fallback):
                    if (isPV_FV) return (isI4a || isI7); // FV pentru i4a sau i7
                    if (isPV_ST) return isI4a;           // ST doar pentru i4a
                    if (isPV_I4B) return false;          // i4b nu la 2
                    if (!isRole12) return false;
                    if (type === "certificat_racordare") return false;
                    // --- DOVEZI PROSUMATOR pentru celelalte statusuri ---
                    if (
                      type === "dovada_prosumator" ||
                      type === "dovada_prosumator_1" ||
                      type === "dovada_prosumator_2"
                    ) {
                      // de dragul consistenței, păstrăm și aici regula pentru 4,7
                      if (["4", "7"].includes(status)) return false;

                      if (type === "dovada_prosumator") {
                        return isI4a || isI4b;
                      }

                      return isI7;
                    }
                    
                    return true;
                  });

                  return visibleAltele.length > 0 ? (
                    <optgroup label="📁 Alte Documente">
                      {visibleAltele.map((type) => (
                        <option key={type} value={type}>
                          {formatLabel(type)}
                        </option>
                      ))}
                    </optgroup>
                  ) : null;
                })()}

              </select>

              {/* Mesaj tip fișier */}
              {["certificat_racordare", "proces_verbal", "proces_verbal_fotovoltaice", "proces_verbal_stocare", "contract_energie", "contract_energie_actualizat", "factura_voucher", "factura_delgaz", "dovada_delgaz", "dovada_prosumator", "dovada_prosumator_1", "dovada_prosumator_2"].includes(selectedDocumentType) ? (
                <p className="text-muted small-message">Incarca un document PDF</p>
              ) : (
                <p className="text-muted small-message">Incarca o imagine JPG, JPEG sau PNG</p>
              )}

              {/* ——— PV special flow pentru i4a / i7 (FV & ST) ——— */}
              {(
                (String(client?.i4a) === "1" || String(client?.i7) === "1") &&
                (
                  (String(client?.i4a) === "1" &&
                    ["proces_verbal_fotovoltaice", "proces_verbal_stocare"].includes(selectedDocumentType)) ||
                  (String(client?.i7) === "1" &&
                    selectedDocumentType === "proces_verbal_fotovoltaice")
                ) &&
                !hasDocType(selectedDocumentType)
              ) ? (
                <div className="mt-2">
                  {/* — Buton generează — */}
                  {pvGeneratedFor !== selectedDocumentType ? (
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleGeneratePV}
                      disabled={isGeneratingPV}
                    >
                      {isGeneratingPV ? "Se genereaza..." : "Genereaza P.V."}
                    </button>
                  ) : (
                    <>
                      {/* — Buton descarcă — */}
                      <button className="btn btn-success" onClick={handleDownloadPV}>
                        Descarca
                      </button>
                      {!pvDownloadedFor || pvDownloadedFor !== selectedDocumentType ? (
                        <p className="text-muted mt-2">
                          Descarca mai intai PDF-ul generat, semneaza-l iar apoi poti incarca documentul in platforma.
                        </p>
                      ) : null}
                    </>
                  )}

                  {/* — Inputul + Butonul de upload apar doar după descărcare — */}
                  {pvDownloadedFor === selectedDocumentType && (
                    <>
                      <input type="file" onChange={handleFileChange} className="form-control mt-3" />
                      <button 
                        className="btn btn-primary mt-2" 
                        onClick={handleUpload}
                        disabled={
                          isUploading || 
                          (
                            ["certificat_racordare","proces_verbal","proces_verbal_fotovoltaice","proces_verbal_stocare","contract_energie","contract_energie_actualizat","factura_voucher"]
                            .includes(selectedDocumentType) &&
                            documents.some(doc => doc.document_type === selectedDocumentType)
                          )
                        }
                      >
                        {isUploading ? "Se incarca..." : "Incarca Document"}
                      </button>
                    </>
                  )}
                </div>
              ) : (
                // ——— Comportamentul NORMAL pentru toate celelalte tipuri ———
                <>
                  <input type="file" onChange={handleFileChange} className="form-control" />
                  <button 
                    className="btn btn-primary mt-2" 
                    onClick={handleUpload}
                    disabled={
                      isUploading || 
                      (
                        ["certificat_racordare","proces_verbal","proces_verbal_fotovoltaice","proces_verbal_stocare","contract_energie","contract_energie_actualizat","factura_voucher"]
                        .includes(selectedDocumentType) &&
                        documents.some(doc => doc.document_type === selectedDocumentType)
                      )
                    }
                  >
                    {isUploading ? "Se incarca..." : "Incarca Document"}
                  </button>
                </>
              )}
            </div>

            <hr className="mt-4" /> 

            <h5 className="mt-3">📑 Documente incarcate:</h5>
            <div className="small-programe-buttons">
              {(client?.i4a === "1" || client?.i7 === "1") && (
                <button
                  className={`small-programe-button ${activeDocTab === "vizita" ? "active" : ""}`}
                  onClick={() => setActiveDocTab("vizita")}
                >
                  Vizita teren
                </button>
              )}
              <button
                className={`small-programe-button ${activeDocTab === "executie" ? "active" : ""}`}
                onClick={() => setActiveDocTab("executie")}
              >
                Executie
              </button>
              <button
                className={`small-programe-button ${activeDocTab === "altele" ? "active" : ""}`}
                onClick={() => setActiveDocTab("altele")}
              >
                Alte documente
              </button>
            </div>

            {currentDocs.length > 0 ? (
              <>
                <ul className="list-group uploaded-documents">
                  {currentDocs.map((doc) => (
                    <li
                      key={doc.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <a
                        href={`https://tj.marenergy.ro${doc.file_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={doc.file_name}
                        className={`file-link ${visitedDocIds.has(String(doc.id)) ? "viewed" : ""}`}
                        onClick={() => markDocVisited(doc.id)}         // click stânga
                        onAuxClick={() => markDocVisited(doc.id)}      // click mijloc / Ctrl+Click
                      >
                        {formatLabel(doc.document_type)}
                      </a>
                      <span className="uploaded-by">
                        De:{" "}
                        {doc.user_id ? (
                          <Link
                            to={`/user/${doc.user_id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <strong>{doc.uploaded_by || "Necunoscut"}</strong>
                          </Link>
                        ) : (
                          <strong>{doc.uploaded_by || "Necunoscut"}</strong>
                        )}
                      </span>
                    </li>
                  ))}
                </ul>

                {docTotalPages > 1 && (
                  <nav className="mt-3">
                    <ul className="pagination">
                      <li className={`page-item ${docPage === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setDocPage(docPage - 1)}>
                          Inapoi
                        </button>
                      </li>

                      {Array.from({ length: docTotalPages }, (_, i) => (
                        <li key={i} className={`page-item ${docPage === i + 1 ? "active" : ""}`}>
                          <button className="page-link" onClick={() => setDocPage(i + 1)}>
                            {i + 1}
                          </button>
                        </li>
                      ))}

                      <li className={`page-item ${docPage === docTotalPages ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setDocPage(docPage + 1)}>
                          Inainte
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </>
            ) : (
              <p className="text-muted">Niciun document in aceasta categorie.</p>
            )}

            <hr />

            {canEditSim && (
              <div className="mt-3">
                <label className="form-label">
                  Ati instalat cartela la beneficiar?
                </label>

                <div className="d-flex gap-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="simDa"
                      checked={simInstalled === "da"}
                      disabled={!canEditSim || isSimConfirmed}
                      onChange={(e) => {
                        if (!canEditSim || isSimConfirmed) return;
                        if (e.target.checked) {
                          setSimInstalled("da");
                        } else {
                          setSimInstalled(null);
                          setSimOperator("");
                          setSimIdentifier("");
                        }
                      }}
                    />
                    <label className="form-check-label" htmlFor="simDa">Da</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="simNu"
                      checked={simInstalled === "nu"}
                      disabled={!canEditSim || isSimConfirmed}
                      onChange={(e) => {
                        if (!canEditSim || isSimConfirmed) return;
                        if (e.target.checked) {
                          setSimInstalled("nu");
                          setSimOperator("");
                          setSimIdentifier("");
                        } else {
                          setSimInstalled(null);
                        }
                      }}
                    />
                    <label className="form-check-label" htmlFor="simNu">Nu</label>
                  </div>
                </div>

                {simInstalled === "da" && (
                  <div className="mt-3">
                    <div className="mb-3">
                      <label className="form-label"><strong>Operator</strong></label>
                      <select
                        className="form-select"
                        value={simOperator}
                        disabled={!canEditSim || isSimConfirmed} 
                        onChange={(e) => setSimOperator(e.target.value)}
                      >
                        <option value="">Selecteaza...</option>
                        <option value="Orange">Orange</option>
                        <option value="Digi">Digi</option>
                        <option value="Vodafone">Vodafone</option>
                      </select>
                    </div>

                    <div>
                      <label className="form-label"><strong>Identificare cartela</strong></label>

                      <div className="d-flex align-items-start gap-2">
                        <input
                          type="text"
                          className="form-control"
                          value={simIdentifier}
                          maxLength={30}
                          disabled={!canEditSim || isSimConfirmed || simInstalled !== "da"}
                          onChange={(e) => setSimIdentifier(e.target.value)}
                          placeholder="Cod cartela sau nr. tel"
                        />

                        {/* ✓ apare doar dacă poate edita, nu e confirmat și există modificări */}
                        {canEditSim && !isSimConfirmed && isSimDirty && (
                          <button
                            type="button"
                            className="btn btn-success sim-save-btn"
                            onClick={handleSaveSimData}
                            disabled={isSavingSim || !isSimSaveValid}                         
                          >
                            {isSavingSim ? "..." : "✓"}
                          </button>
                        )}
                      </div>

                      {isSimConfirmed && (
                        <div className="text-muted mt-1" style={{ fontSize: 13 }}>
                          Cartela confirmata
                        </div>
                      )}

                      {simSaveMessage && (
                        <div className="text-success mt-1" style={{ fontSize: 13 }}>
                          {simSaveMessage}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {["1", "2"].includes(String(client?.status)) && (
              <hr className="mb-3" />
            )}

            <div className={`checkbox-afiseaza-serii form-check mt-3 ${afiseazaSerii ? "mb-4" : ""}`}>
              <input
                type="checkbox"
                className="form-check-input"
                id="toggleSerii"
                checked={afiseazaSerii}
                onChange={(e) => setAfiseazaSerii(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="toggleSerii">
                Afiseaza seriile clientului
              </label>
            </div>

            {afiseazaSerii && (
              <>
                {(client?.i4a === "1" || client?.i7 === "1") && (
                  <div className="mt-3">
                    <div className="d-flex align-items-center gap-2 mt-1">
                      <h4 className="mb-0">Serii Panouri Fotovoltaice</h4>
                      {panelSeries.length > 0 && (
                        <span className="badge-serii-modern">{panelSeries.length}</span>
                      )}
                    </div>

                    {/* === TIP PANOU === */}
                    {(esteStatus2 && !areTipPanouInDB) ? (
                      <div className="mt-2">
                        <hr style={{ borderTop: "1px solid #ccc" }} />
                        <label className="fw-bold">Tip panou</label>
                        <select
                          className="form-control"
                          value={client?.tippanou || tipPanouSelectat}
                          onChange={(e) => {
                            const v = e.target.value;
                            setTipPanouSelectat(v);
                            // salvează imediat după confirm
                            saveEquipmentType({
                              field: "tippanou",
                              value: v,
                              friendlyName: "tipul panoului",
                            });
                          }}
                          disabled={savingType === "tippanou"}
                        >
                          <option value="">Selectează tipul panoului...</option>
                          {OPTIUNI_PANOU.map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </select>
                        {savingType === "tippanou" && (
                          <small className="text-muted">Se salvează…</small>
                        )}
                        <small className="text-muted d-block mt-1">
                          După confirmare, tipul se salvează imediat în sistem.
                        </small>
                        <hr style={{ borderTop: "1px solid #ccc" }} />
                      </div>
                    ) : (
                      // Afișare read-only (inclusiv dacă nu mai e status 2)
                      client?.tippanou && (
                        <p className="mt-2">
                          <strong>Tip panou:</strong> {client.tippanou}
                        </p>
                      )
                    )}

                    {panelSeries.length > 0 ? (
                      <>
                        <ul className="list-group">
                          {currentItems.map((panel) => (
                            <li key={panel.id} className="list-group-item d-flex justify-content-between align-items-center">
                              {panel.series}
                            </li>
                          ))}
                        </ul>

                        {totalPages > 1 && (
                          <nav className="mt-3">
                            <ul className="pagination">
                              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Inapoi</button>
                              </li>
                              {Array.from({ length: totalPages }, (_, i) => (
                                <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                  <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                </li>
                              ))}
                              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Inainte</button>
                              </li>
                            </ul>
                          </nav>
                        )}
                      </>
                    ) : (
                      <p>Nicio serie introdusa</p>
                    )}

                    {(client?.status === "1" || client?.status === "2") && (
                      <div className="serii-input-group mt-2 position-relative">
                        <input
                          type="text"
                          className={`form-control ${panelAddedPing ? "success-flash" : ""}`}
                          placeholder="Introduceți seria panoului"
                          value={newPanel}
                          maxLength={MAX_SERIES_LENGTH}
                          onChange={(e) => setNewPanel(e.target.value)}
                          disabled={((esteStatus2 && !tipPanouReady) || isAddingPanel)}
                        />

                        {/* mic badge ✓ care apare scurt lângă input */}
                        {panelAddedPing && <span className="added-badge" aria-hidden>✓</span>}

                        <button
                          className={`btn ${panelAddedPing ? "btn-success pulse" : "btn-primary"}`}
                          onClick={handleAddPanelSeries}
                          disabled={(esteStatus2 && !tipPanouReady) || isAddingPanel}
                        >
                          {isAddingPanel ? "Se adaugă…" : panelAddedPing ? "Adaugata ✓" : "Adauga Serie"}
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {(client?.i4a === "1" || client?.i7 === "1") && <hr className="mt-4" />}

                {String(client?.i4a) === "1" && (
                  <div className="mt-3">
                    <div className="d-flex align-items-center gap-2 mt-1">
                      <h4 className="mb-0">Serii Acumulatori</h4>
                      {acumulatorSeries.length > 0 && (
                        <span className="badge-serii-modern">{acumulatorSeries.length}</span>
                      )}
                    </div>

                    {/* === TIP ACUMULATOR === */}
                    {(esteStatus2 && !areTipAcumulatorInDB) ? (
                      <div className="mt-2">
                        <hr style={{ borderTop: "1px solid #ccc" }} />
                        <label className="fw-bold">Tip acumulator</label>
                        <select
                          className="form-control"
                          value={client?.tipacumulator || tipAcumulatorSelectat}
                          onChange={(e) => {
                            const v = e.target.value;
                            setTipAcumulatorSelectat(v);
                            saveEquipmentType({
                              field: "tipacumulator",
                              value: v,
                              friendlyName: "tipul acumulatorului",
                            });
                          }}
                          disabled={savingType === "tipacumulator"}
                        >
                          <option value="">Selectează tipul acumulatorului...</option>
                          {OPTIUNI_ACUMULATOR.map((opt) => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </select>
                        {savingType === "tipacumulator" && (
                          <small className="text-muted">Se salvează…</small>
                        )}
                        <hr style={{ borderTop: "1px solid #ccc" }} />
                      </div>
                    ) : (
                      client?.tipacumulator && (
                        <p className="mt-2"><strong>Tip acumulator:</strong> {client.tipacumulator}</p>
                      )
                    )}

                    {acumulatorSeries.length > 0 ? (
                      <ul className="list-group">
                        {acumulatorSeries.map((acumulator) => (
                          <li
                            key={acumulator.id}
                            className="list-group-item d-flex justify-content-between align-items-center"
                          >
                            {acumulator.series}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>Nicio serie de acumulator introdusă</p>
                    )}

                    {(client?.status === "1" || client?.status === "2") && (
                      <div className="serii-input-group mt-2 position-relative">
                        <input
                          type="text"
                          className={`form-control ${acumulatorAddedPing ? "success-flash" : ""}`}
                          placeholder="Introduceți seria acumulatorului"
                          value={newAcumulator}
                          maxLength={MAX_SERIES_LENGTH}
                          onChange={(e) => setNewAcumulator(e.target.value)}
                          disabled={(esteStatus2 && !tipAcumulatorReady) || isAddingAcumulator}
                        />

                        {/* ✓ mic, apare scurt lângă input */}
                        {acumulatorAddedPing && <span className="added-badge" aria-hidden>✓</span>}

                        <button
                          className={`btn ${acumulatorAddedPing ? "btn-success pulse" : "btn-primary"}`}
                          onClick={handleAddAcumulatorSeries}
                          disabled={(esteStatus2 && !tipAcumulatorReady) || isAddingAcumulator}
                        >
                          {isAddingAcumulator ? "Se adauga…" : acumulatorAddedPing ? "Adaugata ✓" : "Adauga Serie"}
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {String(client?.i4a) === "1" && <hr className="mt-4" />}

                <div className="mt-3">
                  <div className="d-flex align-items-center gap-2 mt-1">
                    <h4 className="mb-0">Serii Invertoare</h4>
                    {invertorSeries.length > 0 && (
                      <span className="badge-serii-modern">{invertorSeries.length}</span>
                    )}
                  </div>

                  {/* === TIP INVERTOR === */}
                  {(esteStatus2 && !areTipInvertorInDB) ? (
                    <div className="mt-2">
                      <hr style={{ borderTop: "1px solid #ccc" }} />
                      <label className="fw-bold">Tip invertor</label>
                      <select
                        className="form-control"
                        value={tipInvertorSelectat}                // doar state-ul local aici
                        onChange={(e) => {
                          const v = e.target.value;
                          setTipInvertorSelectat(v);
                          // salvează în DB după confirm
                          saveEquipmentType({
                            field: "tipinvertor",
                            value: v,
                            friendlyName: "tipul invertorului",
                          });
                        }}
                        disabled={savingType === "tipinvertor"}
                      >
                        <option value="">Selectează tipul invertorului...</option>
                        {OPTIUNI_INVERTOR_VIZIBILE.map((opt) => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </select>
                      {savingType === "tipinvertor" && (
                        <small className="text-muted">Se salvează…</small>
                      )}
                      <hr style={{ borderTop: "1px solid #ccc" }} />
                    </div>
                  ) : (
                    client?.tipinvertor && (
                      <p className="mt-2">
                        <strong>Tip invertor:</strong> {client.tipinvertor}
                      </p>
                    )
                  )}

                  {Array.isArray(invertorSeries) && invertorSeries.length > 0 ? (
                    <ul className="list-group">
                      {invertorSeries.map((invertor) => (
                        <li
                          key={invertor.id ?? `${invertor.series_invertor ?? invertor.series}`}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          {/* acceptă ambele chei din backend */}
                          {invertor.series_invertor ?? invertor.series}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>Nicio serie de invertor introdusa</p>
                  )}

                  {(client?.status === "1" || client?.status === "2") && (
                    <div className="serii-input-group mt-2 position-relative">
                      <input
                        type="text"
                        className={`form-control ${invertorAddedPing ? "success-flash" : ""}`}
                        placeholder="Introduceti seria invertorului"
                        value={newInvertor}
                        maxLength={MAX_SERIES_LENGTH}
                        onChange={(e) => setNewInvertor(e.target.value)}
                        disabled={(esteStatus2 && !tipInvertorReady) || isAddingInvertor}
                      />

                      {/* ✓ mic, apare scurt lângă input */}
                      {invertorAddedPing && <span className="added-badge" aria-hidden>✓</span>}

                      <button
                        className={`btn ${invertorAddedPing ? "btn-success pulse" : "btn-primary"}`}
                        onClick={handleAddInvertorSeries}
                        disabled={(esteStatus2 && !tipInvertorReady) || isAddingInvertor}
                      >
                        {isAddingInvertor ? "Se adauga…" : invertorAddedPing ? "Adaugată ✓" : "Adauga Serie"}
                      </button>
                    </div>
                  )}
                </div>

                <hr className="mt-4" />

                <div className="mt-3">
                  <div className="d-flex align-items-center gap-2 mt-1">
                    <h4 className="mb-0">Serii Smart-Meter</h4>
                    {smartMeterSeries.length > 0 && (
                      <span className="badge-serii-modern">{smartMeterSeries.length}</span>
                    )}
                  </div>
                  {smartMeterSeries.length > 0 ? (
                    <ul className="list-group">
                      {smartMeterSeries.map((smartMeter) => (
                        <li key={smartMeter.id} className="list-group-item d-flex justify-content-between align-items-center">
                          {smartMeter.series_smart_meter}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>Nicio serie de Smart Meter introdusa</p>
                  )}

                  {(client?.status === "1" || client?.status === "2") && (
                    <div className="serii-input-group mt-2 position-relative">
                      <input
                        type="text"
                        className={`form-control ${smartMeterAddedPing ? "success-flash" : ""}`}
                        placeholder="Introduceți seria Smart Meter"
                        value={newSmartMeter}
                        maxLength={MAX_SERIES_LENGTH}
                        onChange={(e) => setNewSmartMeter(e.target.value)}
                        disabled={isAddingSmartMeter}
                      />

                      {/* ✓ mic, apare scurt lângă input */}
                      {smartMeterAddedPing && <span className="added-badge" aria-hidden>✓</span>}

                      <button
                        className={`btn ${smartMeterAddedPing ? "btn-success pulse" : "btn-primary"}`}
                        onClick={handleAddSmartMeterSeries}
                        disabled={isAddingSmartMeter}
                      >
                        {isAddingSmartMeter ? "Se adauga…" : smartMeterAddedPing ? "Adaugata ✓" : "Adauga Serie"}
                      </button>
                    </div>
                  )}
                </div>

                <hr className="mt-4" />

                <div className="mt-3">
                  <div className="d-flex align-items-center gap-2 mt-1">
                    <h4 className="mb-0">Serii Dongle 4G</h4>
                    {DongleSeries.length > 0 && (
                      <span className="badge-serii-modern">{DongleSeries.length}</span>
                    )}
                  </div>
                  {DongleSeries.length > 0 ? (
                    <ul className="list-group">
                      {DongleSeries.map((dongle) => (
                        <li key={dongle.id} className="list-group-item d-flex justify-content-between align-items-center">
                          {dongle.series_dongle}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>Nicio serie de Dongle 4G introdusa</p>
                  )}

                  {(client?.status === "1" || client?.status === "2") && (
                    <div className="serii-input-group mt-2 position-relative">
                      <input
                        type="text"
                        className={`form-control ${DongleAddedPing ? "success-flash" : ""}`}
                        placeholder="Introduceți seria Dongle 4G"
                        value={newDongle}
                        maxLength={MAX_SERIES_LENGTH}
                        onChange={(e) => setNewDongle(e.target.value)}
                        disabled={isAddingDongle}
                      />

                      {/* ✓ mic, apare scurt lângă input */}
                      {DongleAddedPing && <span className="added-badge" aria-hidden>✓</span>}

                      <button
                        className={`btn ${DongleAddedPing ? "btn-success pulse" : "btn-primary"}`}
                        onClick={handleAddDongleSeries}
                        disabled={isAddingDongle}
                      >
                        {isAddingDongle ? "Se adauga…" : DongleAddedPing ? "Adaugata ✓" : "Adauga Serie"}
                      </button>
                    </div>
                  )}

                  <hr className="mt-4" />

                  {((user?.i4a === "1" && panelSeries.length > 0) ||
                    (user?.i4b === "1" && acumulatorSeries.length > 0) ||
                    (user?.i7 === "1" && panelSeries.length > 0)) && (
                    <button className="btn btn-success mt-3" onClick={handleDownloadExcel}>
                      📥 Descarca Serii (Excel)
                    </button>
                  )}
                </div>    
              </>
            )}
          </>
        )}

        <hr className="mt-4" />
        {(String(user?.role) === "1" || String(user?.role) === "2") && (
          <button className="btn btn-info mt-3" onClick={() => setShowProsumatorModal(true)}>
            Dosar Prosumator
          </button>
        )}

        <button
          className={`btn ${!(String(user?.role) === "1" || String(user?.role) === "2") ? "btn-info" : "btn-secondary"} mt-3 ml-2`}
          onClick={() => setShowGeneralLogsModal(true)}
        >
          Istoric Client
        </button>

        <Link to={`/clients${from}`} className="btn btn-primary mt-3">
          Inapoi la Clienti
        </Link>

        {((isVisitComplete && lipsescPozePlanAmplasament) || isEditing)
          ? <br />
          : null}

        {isVisitComplete &&
          !isEditing &&
          lipsescPozePlanAmplasament && (
            <button
              className="btn btn-warning mb-3"
              onClick={() => {
                setOriginalClientData(client);
                setSelectedDocumentType("poze_plan_amplasament");
                setIsEditing(true);
              }}
            >
              Editeaza Vizita
            </button>
          )}

        {isEditing && (
          <button 
            className="btn btn-outline-danger mb-3"
            onClick={() => {
              const confirmExit = window.confirm("Esti sigur ca vrei sa iesi din modul de editare?\nModificarile facute nu vor fi salvate.");
              if (confirmExit) {
                setClient(originalClientData); // restaurăm datele originale
                setIsEditing(false);          // ieșim din modul editare
              }
            }}
          >
            Renunta la Editare
          </button>
        )}
        <hr />
      </div>

      {showProsumatorModal && (
        <Modal title="Istoric Dosar Prosumator" logs={prosumatorLogs} newLog={newProsumatorLog} setNewLog={setNewProsumatorLog} handleAddLog={handleAddProsumatorLog} closeModal={() => setShowProsumatorModal(false)} />
      )}
      {showGeneralLogsModal && (
        <Modal title="Istoric Client" logs={generalLogs} newLog={newGeneralLog} setNewLog={setNewGeneralLog} handleAddLog={handleAddGeneralLog} closeModal={() => setShowGeneralLogsModal(false)} />
      )}

      {isChangingStatus && (
        <div className="screen-blocker" role="status" aria-live="assertive" aria-label="Se procesează schimbarea de status">
          <div className="blocker-content">
            <div className="loader" aria-hidden="true" />
            <div className="blocker-text">
              <strong>Se procesează schimbarea de status…</strong>
              <span>Te rugăm așteaptă câteva momente.</span>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

const Modal = ({ title, logs, newLog, setNewLog, handleAddLog, closeModal }) => (
  <div className="modal show d-block" style={{ background: "rgba(0, 0, 0, 0.5)" }}>
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button className="close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <ul className="list-group">
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <li key={index} className="list-group-item">
                  <strong>{new Date(log.created_at).toLocaleString()}</strong> -
                  <span style={{ color: "blue", fontWeight: "bold" }}>{log.user_name || "Necunoscut"}:</span> {log.message}
                </li>
              ))
            ) : (
              <p>Niciun mesaj adaugat</p>
            )}
          </ul>
          <textarea className="form-control mt-3" rows="3" placeholder="Adaugă un mesaj..." value={newLog} onChange={(e) => setNewLog(e.target.value)}></textarea>
          <button className="btn btn-primary mt-2" onClick={handleAddLog}>Adauga Mesaj</button>
        </div>
      </div>
    </div>
  </div>
);

export default ClientProfile;